var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loading
        ? _c(
            "div",
            { staticClass: "text-xs-center tf_loading" },
            [
              _c("v-progress-circular", {
                staticClass: "primary--text",
                attrs: { indeterminate: "", size: 100, width: 1 }
              })
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "mb-5" },
            [
              _c(
                "v-container",
                { attrs: { "grid-list-lg": "" } },
                [
                  _c(
                    "v-layout",
                    {
                      attrs: { row: "", wrap: "", "justify-space-between": "" }
                    },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs6: "", sm4: "", md4: "" } },
                        [
                          _c("wz-select-one-site", {
                            on: { "update:site": _vm.updateSite }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.isLevelFaq()
                        ? _c(
                            "v-flex",
                            { attrs: { xs6: "", sm4: "", md4: "" } },
                            [
                              _vm.$store.state._Sites.siteSelected
                                .DSK_BOT_ONOFF == "1"
                                ? _c(
                                    "div",
                                    [
                                      _c("wz-avatar", {
                                        attrs: {
                                          username: JSON.parse(
                                            _vm.$store.state._Sites.siteSelected
                                              .DSK_BOT_USER
                                          ).user_name,
                                          src:
                                            _vm.domaine +
                                            "/public/media/user/small/" +
                                            JSON.parse(
                                              _vm.$store.state._Sites
                                                .siteSelected.DSK_BOT_USER
                                            ).user_id +
                                            "_avatar.jpg",
                                          size: "35px"
                                        }
                                      }),
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(
                                            JSON.parse(
                                              _vm.$store.state._Sites
                                                .siteSelected.DSK_BOT_USER
                                            ).user_name
                                          ) +
                                          "\n          "
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-expansion-panel",
                [
                  _c(
                    "v-expansion-panel-content",
                    {
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function() {
                            return [
                              _c("div", [_vm._v(_vm._s(_vm.$t("AIPromptSys")))])
                            ]
                          },
                          proxy: true
                        }
                      ])
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "v-card",
                        [
                          _c("v-card-text", { staticClass: "pb-0" }, [
                            _c(
                              "div",
                              { staticClass: "text-xs-right" },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      small: "",
                                      color: "primary",
                                      dark: ""
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.enhance("personality")
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  Enhance with AI\n                  "
                                    ),
                                    _c("v-icon", { attrs: { right: "" } }, [
                                      _vm._v("draw")
                                    ])
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      small: "",
                                      color: "primary",
                                      dark: ""
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.version("personality")
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  Historic\n                  "
                                    ),
                                    _c("v-icon", { attrs: { right: "" } }, [
                                      _vm._v("rebase_edit")
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _vm.loadingPrompt
                            ? _c(
                                "div",
                                { staticClass: "text-xs-center tf_loading" },
                                [
                                  _c("v-progress-circular", {
                                    staticClass: "primary--text",
                                    attrs: {
                                      indeterminate: "",
                                      size: 100,
                                      width: 1
                                    }
                                  })
                                ],
                                1
                              )
                            : _c(
                                "v-card-text",
                                [
                                  _c(
                                    "v-container",
                                    [
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs12: "" } },
                                            [
                                              _c(
                                                "h3",
                                                { staticClass: "mb-0" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("AIPersonnality")
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("v-textarea", {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "AIPersonnalityDesc"
                                                  ),
                                                  counter: "",
                                                  maxlength: "500"
                                                },
                                                model: {
                                                  value: _vm.prompt_personality,
                                                  callback: function($$v) {
                                                    _vm.prompt_personality = $$v
                                                  },
                                                  expression:
                                                    "prompt_personality"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs12: "" } },
                                            [
                                              _c(
                                                "h3",
                                                { staticClass: "mb-0" },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("AIEnviron"))
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("v-textarea", {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "AIEnvironDesc"
                                                  ),
                                                  counter: "",
                                                  maxlength: "500"
                                                },
                                                model: {
                                                  value: _vm.prompt_environment,
                                                  callback: function($$v) {
                                                    _vm.prompt_environment = $$v
                                                  },
                                                  expression:
                                                    "prompt_environment"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs12: "" } },
                                            [
                                              _c(
                                                "h3",
                                                { staticClass: "mb-0" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("AIObjective")
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("v-textarea", {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "AIObjectiveDesc"
                                                  ),
                                                  counter: "",
                                                  maxlength: "500"
                                                },
                                                model: {
                                                  value: _vm.prompt_objectif,
                                                  callback: function($$v) {
                                                    _vm.prompt_objectif = $$v
                                                  },
                                                  expression: "prompt_objectif"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs12: "" } },
                                            [
                                              _c(
                                                "h3",
                                                { staticClass: "mb-0" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("AICommunication")
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("v-textarea", {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "AICommunicationDesc"
                                                  ),
                                                  counter: "",
                                                  maxlength: "500"
                                                },
                                                model: {
                                                  value:
                                                    _vm.prompt_communication,
                                                  callback: function($$v) {
                                                    _vm.prompt_communication = $$v
                                                  },
                                                  expression:
                                                    "prompt_communication"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs12: "" } },
                                            [
                                              _c(
                                                "h3",
                                                { staticClass: "mb-0" },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("AIQuestion"))
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("v-textarea", {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "AIQuestionDesc"
                                                  ),
                                                  counter: "",
                                                  maxlength: "500"
                                                },
                                                model: {
                                                  value: _vm.prompt_questions,
                                                  callback: function($$v) {
                                                    _vm.prompt_questions = $$v
                                                  },
                                                  expression: "prompt_questions"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs12: "" } },
                                            [
                                              _c(
                                                "h3",
                                                { staticClass: "mb-0" },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("AIRules"))
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("v-textarea", {
                                                attrs: {
                                                  label: _vm.$t("AIRulesDesc"),
                                                  counter: "",
                                                  maxlength: "500"
                                                },
                                                model: {
                                                  value: _vm.prompt_rules,
                                                  callback: function($$v) {
                                                    _vm.prompt_rules = $$v
                                                  },
                                                  expression: "prompt_rules"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs12: "" } },
                                            [
                                              _c(
                                                "h3",
                                                { staticClass: "mb-0" },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("AITools"))
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("v-textarea", {
                                                attrs: {
                                                  label: _vm.$t("AIToolsDesc"),
                                                  counter: "",
                                                  maxlength: "500"
                                                },
                                                model: {
                                                  value: _vm.prompt_tools,
                                                  callback: function($$v) {
                                                    _vm.prompt_tools = $$v
                                                  },
                                                  expression: "prompt_tools"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs12: "" } },
                                            [
                                              _c(
                                                "h3",
                                                { staticClass: "mb-0" },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("AICustom"))
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("v-textarea", {
                                                attrs: {
                                                  label: _vm.$t("AICustomDesc"),
                                                  counter: "",
                                                  maxlength: "5000",
                                                  rows: "5",
                                                  "auto-grow": ""
                                                },
                                                model: {
                                                  value: _vm.prompt_custom,
                                                  callback: function($$v) {
                                                    _vm.prompt_custom = $$v
                                                  },
                                                  expression: "prompt_custom"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs12: "" } },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label:
                                                    "Que change cette version ?",
                                                  hint:
                                                    "Décrivez brièvement les modifications apportées — visible dans l'historique.",
                                                  "persistent-hint": "",
                                                  maxlength: "255",
                                                  counter: ""
                                                },
                                                model: {
                                                  value: _vm.prompt_name,
                                                  callback: function($$v) {
                                                    _vm.prompt_name = $$v
                                                  },
                                                  expression: "prompt_name"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      0
                                        ? _c(
                                            "v-layout",
                                            { attrs: { row: "", wrap: "" } },
                                            [
                                              _c(
                                                "v-flex",
                                                { attrs: { xs12: "" } },
                                                [
                                                  _c(
                                                    "h3",
                                                    { staticClass: "mb-0" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "AiPromptGlobal"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("v-textarea", {
                                                    attrs: {
                                                      label: _vm.$t(
                                                        "AiPromptGlobalDesc"
                                                      ),
                                                      counter: "",
                                                      disabled: ""
                                                    },
                                                    model: {
                                                      value: _vm.prompt,
                                                      callback: function($$v) {
                                                        _vm.prompt = $$v
                                                      },
                                                      expression: "prompt"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-expansion-panel-content",
                    {
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function() {
                            return [
                              _c("div", [
                                _vm._v(_vm._s(_vm.$t("AIAccueilBot")))
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ])
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "v-card",
                        [
                          _vm.loadingPrompt
                            ? _c(
                                "div",
                                { staticClass: "text-xs-center tf_loading" },
                                [
                                  _c("v-progress-circular", {
                                    staticClass: "primary--text",
                                    attrs: {
                                      indeterminate: "",
                                      size: 100,
                                      width: 1
                                    }
                                  })
                                ],
                                1
                              )
                            : _c(
                                "v-card-text",
                                [
                                  _c(
                                    "v-container",
                                    [
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs12: "" } },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: _vm.$t("ADMessAcc"),
                                                  placeholder: _vm.$t(
                                                    "ADMessAccExem"
                                                  )
                                                },
                                                model: {
                                                  value: _vm.messageAccueil,
                                                  callback: function($$v) {
                                                    _vm.messageAccueil = $$v
                                                  },
                                                  expression: "messageAccueil"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs12: "" } },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: _vm.$t("AIQuestion1"),
                                                  placeholder: _vm.$t(
                                                    "AIQuestion1Sample"
                                                  )
                                                },
                                                model: {
                                                  value: _vm.questionAuto1,
                                                  callback: function($$v) {
                                                    _vm.questionAuto1 = $$v
                                                  },
                                                  expression: "questionAuto1"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs12: "" } },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: _vm.$t("AIQuestion2")
                                                },
                                                model: {
                                                  value: _vm.questionAuto2,
                                                  callback: function($$v) {
                                                    _vm.questionAuto2 = $$v
                                                  },
                                                  expression: "questionAuto2"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs12: "" } },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: _vm.$t("AIQuestion3")
                                                },
                                                model: {
                                                  value: _vm.questionAuto3,
                                                  callback: function($$v) {
                                                    _vm.questionAuto3 = $$v
                                                  },
                                                  expression: "questionAuto3"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs12: "" } },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: _vm.$t("AIQuestion4")
                                                },
                                                model: {
                                                  value: _vm.questionAuto4,
                                                  callback: function($$v) {
                                                    _vm.questionAuto4 = $$v
                                                  },
                                                  expression: "questionAuto4"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs12: "" } },
                                            [
                                              _c("v-switch", {
                                                attrs: {
                                                  label: _vm.comportment
                                                    ? _vm.$t(
                                                        "AIQuestionClickChoicesSend"
                                                      )
                                                    : _vm.$t(
                                                        "AIQuestionClickChoicesDisplay"
                                                      ),
                                                  light: "",
                                                  color: "primary"
                                                },
                                                on: {
                                                  change: function($event) {
                                                    return _vm.switchComportment()
                                                  }
                                                },
                                                model: {
                                                  value: _vm.comportment,
                                                  callback: function($$v) {
                                                    _vm.comportment = $$v
                                                  },
                                                  expression: "comportment"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs12: "" } },
                                            [
                                              _c("v-switch", {
                                                attrs: {
                                                  label: _vm.showEx
                                                    ? _vm.$t("AIExempleShow") +
                                                      " ON"
                                                    : _vm.$t("AIExempleShow") +
                                                      " OFF",
                                                  light: "",
                                                  color: "primary"
                                                },
                                                on: {
                                                  change: function($event) {
                                                    return _vm.switchExemple()
                                                  }
                                                },
                                                model: {
                                                  value: _vm.showEx,
                                                  callback: function($$v) {
                                                    _vm.showEx = $$v
                                                  },
                                                  expression: "showEx"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-expansion-panel-content",
                    {
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function() {
                            return [
                              _c("div", [_vm._v(_vm._s(_vm.$t("AIDescTitle")))])
                            ]
                          },
                          proxy: true
                        }
                      ])
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "v-card",
                        [
                          _vm.loadingPrompt
                            ? _c(
                                "div",
                                { staticClass: "text-xs-center tf_loading" },
                                [
                                  _c("v-progress-circular", {
                                    staticClass: "primary--text",
                                    attrs: {
                                      indeterminate: "",
                                      size: 100,
                                      width: 1
                                    }
                                  })
                                ],
                                1
                              )
                            : _c(
                                "v-card-text",
                                [
                                  _c(
                                    "v-container",
                                    [
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs12: "" } },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: _vm.$t("AIScanUrl"),
                                                  placeholder: "www.website.com"
                                                },
                                                model: {
                                                  value: _vm.parseUrl,
                                                  callback: function($$v) {
                                                    _vm.parseUrl = $$v
                                                  },
                                                  expression: "parseUrl"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      !_vm.isLevelFaq()
                                        ? _c(
                                            "v-layout",
                                            { attrs: { row: "", wrap: "" } },
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  attrs: { md4: "", xs12: "" }
                                                },
                                                [
                                                  _c("v-select", {
                                                    attrs: {
                                                      items: _vm.methodList,
                                                      label: "méthode",
                                                      disabled: ""
                                                    },
                                                    on: {
                                                      change: _vm.changeModel
                                                    },
                                                    model: {
                                                      value: _vm.methodSelect,
                                                      callback: function($$v) {
                                                        _vm.methodSelect = $$v
                                                      },
                                                      expression: "methodSelect"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-flex",
                                                {
                                                  attrs: { md8: "", xs12: "" }
                                                },
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      label: _vm.$t(
                                                        "AIScanHtml"
                                                      ),
                                                      placeholder: ".className",
                                                      disabled: ""
                                                    },
                                                    model: {
                                                      value: _vm.parseElement,
                                                      callback: function($$v) {
                                                        _vm.parseElement = $$v
                                                      },
                                                      expression: "parseElement"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.isLevelFaq()
                                        ? _c(
                                            "v-layout",
                                            { attrs: { row: "", wrap: "" } },
                                            [
                                              _c(
                                                "v-flex",
                                                {
                                                  attrs: { md3: "", xs12: "" }
                                                },
                                                [
                                                  _c(
                                                    "v-subheader",
                                                    { staticClass: "pl-0" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "AINumResSearch"
                                                          )
                                                        ) +
                                                          " : " +
                                                          _vm._s(
                                                            _vm.sliderSearchResponse
                                                          )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("v-slider", {
                                                    attrs: {
                                                      "thumb-label": "",
                                                      step: "1",
                                                      ticks: "always",
                                                      max: _vm.maxSearch,
                                                      min: _vm.minSearch
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.sliderSearchResponse,
                                                      callback: function($$v) {
                                                        _vm.sliderSearchResponse = $$v
                                                      },
                                                      expression:
                                                        "sliderSearchResponse"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.isLevelFaq()
                                        ? _c(
                                            "v-layout",
                                            { attrs: { row: "", wrap: "" } },
                                            [
                                              !_vm.isLevelFaq()
                                                ? _c(
                                                    "v-flex",
                                                    { attrs: { xs12: "" } },
                                                    [
                                                      _c(
                                                        "h3",
                                                        {
                                                          staticClass:
                                                            "headline mb-0"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "AIPromptResSearch"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("v-textarea", {
                                                        attrs: {
                                                          label: _vm.$t(
                                                            "AIPromptResSearchTxt"
                                                          ),
                                                          counter: "",
                                                          maxlength: "5000"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.promptSearch,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.promptSearch = $$v
                                                          },
                                                          expression:
                                                            "promptSearch"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.isLevelFaq()
                                        ? _c(
                                            "v-layout",
                                            { attrs: { row: "", wrap: "" } },
                                            [
                                              _c(
                                                "v-flex",
                                                { attrs: { xs12: "" } },
                                                [
                                                  _c("v-switch", {
                                                    attrs: {
                                                      label: _vm.$t(
                                                        "AIProdSelect"
                                                      )
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.productSelectAuto,
                                                      callback: function($$v) {
                                                        _vm.productSelectAuto = $$v
                                                      },
                                                      expression:
                                                        "productSelectAuto"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-expansion-panel-content",
                    {
                      class: [_vm.getPermissionsAdmin ? "active" : "hidden"],
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function() {
                            return [
                              _c("div", [
                                _vm._v(
                                  _vm._s(_vm.$t("AIParsPageTitle")) +
                                    " (" +
                                    _vm._s(_vm.parsingSelectif.length) +
                                    ")"
                                )
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ])
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-container",
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { xs12: "" } },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(_vm.$t("AIParsPageTxt")) +
                                              "\n                    "
                                          ),
                                          _c(
                                            "v-expansion-panel",
                                            _vm._l(
                                              _vm.parsingSelectif,
                                              function(parsing, i) {
                                                return _c(
                                                  "v-expansion-panel-content",
                                                  {
                                                    key: i,
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "header",
                                                          fn: function() {
                                                            return [
                                                              _c("div", [
                                                                _c("strong", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      parsing.name
                                                                    )
                                                                  )
                                                                ])
                                                              ])
                                                            ]
                                                          },
                                                          proxy: true
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  },
                                                  [
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-card",
                                                      [
                                                        _c(
                                                          "v-card-text",
                                                          [
                                                            _c(
                                                              "v-layout",
                                                              {
                                                                attrs: {
                                                                  row: "",
                                                                  wrap: ""
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      md3: "",
                                                                      xs6: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    !parsing.default
                                                                      ? _c(
                                                                          "v-text-field",
                                                                          {
                                                                            attrs: {
                                                                              label: _vm.$t(
                                                                                "AIParsPageUrl"
                                                                              ),
                                                                              placeholder: _vm.$t(
                                                                                "AIParsPageUrl"
                                                                              )
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                parsing.name,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  parsing,
                                                                                  "name",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "parsing.name"
                                                                            }
                                                                          }
                                                                        )
                                                                      : _c(
                                                                          "v-text-field",
                                                                          {
                                                                            attrs: {
                                                                              label: _vm.$t(
                                                                                "AIParsPageDefaut"
                                                                              ),
                                                                              disabled:
                                                                                ""
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                parsing.name,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  parsing,
                                                                                  "name",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "parsing.name"
                                                                            }
                                                                          }
                                                                        )
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      md3: "",
                                                                      xs6: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-select",
                                                                      {
                                                                        attrs: {
                                                                          items:
                                                                            _vm.methodList,
                                                                          label: _vm.$t(
                                                                            "AIParsPageMethode"
                                                                          )
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            parsing.methode,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              parsing,
                                                                              "methode",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "parsing.methode"
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "v-flex",
                                                                  {
                                                                    attrs: {
                                                                      md5: "",
                                                                      xs11: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-textarea",
                                                                      {
                                                                        attrs: {
                                                                          label: _vm.$t(
                                                                            "AIScanHtml"
                                                                          ),
                                                                          hint: _vm.$t(
                                                                            "AIParsPageExem"
                                                                          ),
                                                                          "persistent-hint":
                                                                            "",
                                                                          box:
                                                                            ""
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            parsing.elements,
                                                                          callback: function(
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              parsing,
                                                                              "elements",
                                                                              $$v
                                                                            )
                                                                          },
                                                                          expression:
                                                                            "parsing.elements"
                                                                        }
                                                                      }
                                                                    )
                                                                  ],
                                                                  1
                                                                ),
                                                                _vm._v(" "),
                                                                !parsing.default
                                                                  ? _c(
                                                                      "v-flex",
                                                                      {
                                                                        attrs: {
                                                                          md1:
                                                                            "",
                                                                          xs1:
                                                                            ""
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-tooltip",
                                                                          {
                                                                            attrs: {
                                                                              left:
                                                                                ""
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "template",
                                                                              {
                                                                                slot:
                                                                                  "activator"
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "v-btn",
                                                                                  {
                                                                                    attrs: {
                                                                                      flat:
                                                                                        "",
                                                                                      icon:
                                                                                        "",
                                                                                      color:
                                                                                        "red lighten-2"
                                                                                    },
                                                                                    nativeOn: {
                                                                                      click: function(
                                                                                        $event
                                                                                      ) {
                                                                                        return _vm.delParsing(
                                                                                          parsing
                                                                                        )
                                                                                      }
                                                                                    }
                                                                                  },
                                                                                  [
                                                                                    _c(
                                                                                      "v-icon",
                                                                                      [
                                                                                        _vm._v(
                                                                                          "delete"
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  ],
                                                                                  1
                                                                                )
                                                                              ],
                                                                              1
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm.$t(
                                                                                      "AISuppParse"
                                                                                    )
                                                                                  )
                                                                                )
                                                                              ]
                                                                            )
                                                                          ],
                                                                          2
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  : _vm._e()
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    flat: "",
                                                    icon: "",
                                                    color: "primary"
                                                  },
                                                  nativeOn: {
                                                    click: function($event) {
                                                      return _vm.addParsing.apply(
                                                        null,
                                                        arguments
                                                      )
                                                    }
                                                  }
                                                },
                                                [_c("v-icon", [_vm._v("add")])],
                                                1
                                              ),
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(_vm.$t("AIAddParse")) +
                                                  "\n                    "
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-expansion-panel-content",
                    {
                      class: [_vm.getPermissionsAdmin ? "active" : "hidden"],
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function() {
                            return [
                              _c("div", [
                                _vm._v(
                                  _vm._s(_vm.$t("AIFunctionTitle")) +
                                    " (" +
                                    _vm._s(_vm.fonctionsNum) +
                                    "/9)"
                                )
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ])
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-container",
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { xs12: "" } },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t("AIFunctionContent")
                                              ) +
                                              "\n                    "
                                          ),
                                          _c(
                                            "v-expansion-panel",
                                            _vm._l(_vm.fonctions, function(
                                              fonction,
                                              i
                                            ) {
                                              return _c(
                                                "v-expansion-panel-content",
                                                {
                                                  key: i,
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "header",
                                                        fn: function() {
                                                          return [
                                                            _c(
                                                              "div",
                                                              {
                                                                style: _vm
                                                                  .functionCallOnOff[
                                                                  i
                                                                ]
                                                                  ? "opacity: 1"
                                                                  : "opacity: 0.5"
                                                              },
                                                              [
                                                                _c("strong", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      fonction.name
                                                                        ? fonction.name
                                                                        : fonction.type
                                                                    )
                                                                  )
                                                                ]),
                                                                _vm._v(
                                                                  " : (" +
                                                                    _vm._s(
                                                                      fonction.description
                                                                    ) +
                                                                    ")"
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        },
                                                        proxy: true
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                },
                                                [
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-card",
                                                    [
                                                      _c(
                                                        "v-card-text",
                                                        [
                                                          _c("v-switch", {
                                                            attrs: {
                                                              label:
                                                                "Tool " +
                                                                i +
                                                                ": " +
                                                                (_vm
                                                                  .functionCallOnOff[
                                                                  i
                                                                ]
                                                                  ? "ON"
                                                                  : "OFF")
                                                            },
                                                            model: {
                                                              value:
                                                                _vm
                                                                  .functionCallOnOff[
                                                                  i
                                                                ],
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.functionCallOnOff,
                                                                  i,
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "functionCallOnOff[i]"
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          i === 0
                                                            ? _c("v-textarea", {
                                                                model: {
                                                                  value:
                                                                    _vm.function0,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.function0 = $$v
                                                                  },
                                                                  expression:
                                                                    "function0"
                                                                }
                                                              })
                                                            : i === 1
                                                            ? _c("v-textarea", {
                                                                model: {
                                                                  value:
                                                                    _vm.function1,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.function1 = $$v
                                                                  },
                                                                  expression:
                                                                    "function1"
                                                                }
                                                              })
                                                            : i === 2
                                                            ? _c("v-textarea", {
                                                                model: {
                                                                  value:
                                                                    _vm.function2,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.function2 = $$v
                                                                  },
                                                                  expression:
                                                                    "function2"
                                                                }
                                                              })
                                                            : i === 3
                                                            ? _c("v-textarea", {
                                                                model: {
                                                                  value:
                                                                    _vm.function3,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.function3 = $$v
                                                                  },
                                                                  expression:
                                                                    "function3"
                                                                }
                                                              })
                                                            : i === 4
                                                            ? _c("v-textarea", {
                                                                model: {
                                                                  value:
                                                                    _vm.function4,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.function4 = $$v
                                                                  },
                                                                  expression:
                                                                    "function4"
                                                                }
                                                              })
                                                            : i === 5
                                                            ? _c("v-textarea", {
                                                                model: {
                                                                  value:
                                                                    _vm.function5,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.function5 = $$v
                                                                  },
                                                                  expression:
                                                                    "function5"
                                                                }
                                                              })
                                                            : i === 6
                                                            ? _c("v-textarea", {
                                                                model: {
                                                                  value:
                                                                    _vm.function6,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.function6 = $$v
                                                                  },
                                                                  expression:
                                                                    "function6"
                                                                }
                                                              })
                                                            : i === 7
                                                            ? _c("v-textarea", {
                                                                model: {
                                                                  value:
                                                                    _vm.function7,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.function7 = $$v
                                                                  },
                                                                  expression:
                                                                    "function7"
                                                                }
                                                              })
                                                            : i === 8
                                                            ? _c("v-textarea", {
                                                                model: {
                                                                  value:
                                                                    _vm.function8,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.function8 = $$v
                                                                  },
                                                                  expression:
                                                                    "function8"
                                                                }
                                                              })
                                                            : _vm._e()
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            }),
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.addFonctionsNum === 1 &&
                                          _vm.fonctionsNum !==
                                            _vm.addFonctionsNum
                                            ? _c(
                                                "v-card",
                                                [
                                                  _c(
                                                    "v-card-text",
                                                    [
                                                      _c("v-textarea", {
                                                        model: {
                                                          value: _vm.function0,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.function0 = $$v
                                                          },
                                                          expression:
                                                            "function0"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm.addFonctionsNum === 2 &&
                                              _vm.fonctionsNum !==
                                                _vm.addFonctionsNum
                                            ? _c(
                                                "v-card",
                                                [
                                                  _c(
                                                    "v-card-text",
                                                    [
                                                      _c("v-textarea", {
                                                        model: {
                                                          value: _vm.function1,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.function1 = $$v
                                                          },
                                                          expression:
                                                            "function1"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm.addFonctionsNum === 3 &&
                                              _vm.fonctionsNum !==
                                                _vm.addFonctionsNum
                                            ? _c(
                                                "v-card",
                                                [
                                                  _c(
                                                    "v-card-text",
                                                    [
                                                      _c("v-textarea", {
                                                        model: {
                                                          value: _vm.function2,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.function2 = $$v
                                                          },
                                                          expression:
                                                            "function2"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm.addFonctionsNum === 4 &&
                                              _vm.fonctionsNum !==
                                                _vm.addFonctionsNum
                                            ? _c(
                                                "v-card",
                                                [
                                                  _c(
                                                    "v-card-text",
                                                    [
                                                      _c("v-textarea", {
                                                        model: {
                                                          value: _vm.function3,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.function3 = $$v
                                                          },
                                                          expression:
                                                            "function3"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm.addFonctionsNum === 5 &&
                                              _vm.fonctionsNum !==
                                                _vm.addFonctionsNum
                                            ? _c(
                                                "v-card",
                                                [
                                                  _c(
                                                    "v-card-text",
                                                    [
                                                      _c("v-textarea", {
                                                        model: {
                                                          value: _vm.function4,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.function4 = $$v
                                                          },
                                                          expression:
                                                            "function4"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm.addFonctionsNum === 6 &&
                                              _vm.fonctionsNum !==
                                                _vm.addFonctionsNum
                                            ? _c(
                                                "v-card",
                                                [
                                                  _c(
                                                    "v-card-text",
                                                    [
                                                      _c("v-textarea", {
                                                        model: {
                                                          value: _vm.function5,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.function5 = $$v
                                                          },
                                                          expression:
                                                            "function5"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm.addFonctionsNum === 7 &&
                                              _vm.fonctionsNum !==
                                                _vm.addFonctionsNum
                                            ? _c(
                                                "v-card",
                                                [
                                                  _c(
                                                    "v-card-text",
                                                    [
                                                      _c("v-textarea", {
                                                        model: {
                                                          value: _vm.function6,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.function6 = $$v
                                                          },
                                                          expression:
                                                            "function6"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm.addFonctionsNum === 8 &&
                                              _vm.fonctionsNum !==
                                                _vm.addFonctionsNum
                                            ? _c(
                                                "v-card",
                                                [
                                                  _c(
                                                    "v-card-text",
                                                    [
                                                      _c("v-textarea", {
                                                        model: {
                                                          value: _vm.function7,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.function7 = $$v
                                                          },
                                                          expression:
                                                            "function7"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm.addFonctionsNum === 9 &&
                                              _vm.fonctionsNum !==
                                                _vm.addFonctionsNum
                                            ? _c(
                                                "v-card",
                                                [
                                                  _c(
                                                    "v-card-text",
                                                    [
                                                      _c("v-textarea", {
                                                        model: {
                                                          value: _vm.function8,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.function8 = $$v
                                                          },
                                                          expression:
                                                            "function8"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.addFonctionsNum -
                                            _vm.fonctionsNum ===
                                            0 &&
                                          _vm.fonctionsNum < 8 &&
                                          _vm.addFonctionsNum < 8
                                            ? _c(
                                                "div",
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        flat: "",
                                                        icon: "",
                                                        color: "primary"
                                                      },
                                                      nativeOn: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.addFunction.apply(
                                                            null,
                                                            arguments
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v("add")
                                                      ])
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.$t("AIAddFunction")
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-expansion-panel-content",
                    {
                      class: [_vm.getPermissionsAdmin ? "active" : "hidden"],
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function() {
                            return [
                              _c("div", [_vm._v(_vm._s(_vm.$t("AILLMTitle")))])
                            ]
                          },
                          proxy: true
                        }
                      ])
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "v-card",
                        [
                          _vm.loadingPrompt
                            ? _c(
                                "div",
                                { staticClass: "text-xs-center tf_loading" },
                                [
                                  _c("v-progress-circular", {
                                    staticClass: "primary--text",
                                    attrs: {
                                      indeterminate: "",
                                      size: 100,
                                      width: 1
                                    }
                                  })
                                ],
                                1
                              )
                            : _c(
                                "v-card-text",
                                [
                                  _c(
                                    "v-container",
                                    [
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { md4: "", xs12: "" } },
                                            [
                                              _c("v-select", {
                                                attrs: {
                                                  items: _vm.modelListObject,
                                                  "item-text": "name",
                                                  "item-value": "tokens",
                                                  label: this.$t("AIModele"),
                                                  hint:
                                                    this.$t("AILLMTokenMax") +
                                                    " " +
                                                    _vm.modelSelect.tokens,
                                                  "persistent-hint": "",
                                                  "return-object": ""
                                                },
                                                on: {
                                                  change: _vm.changeMethod
                                                },
                                                model: {
                                                  value: _vm.modelSelect,
                                                  callback: function($$v) {
                                                    _vm.modelSelect = $$v
                                                  },
                                                  expression: "modelSelect"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.isGptModel
                                            ? _c(
                                                "v-flex",
                                                {
                                                  attrs: { md4: "", xs12: "" }
                                                },
                                                [
                                                  _c("v-select", {
                                                    attrs: {
                                                      items: _vm.APIListObject,
                                                      "item-text": "name",
                                                      label: this.$t(
                                                        "APIModele"
                                                      ),
                                                      "persistent-hint": "",
                                                      "return-object": ""
                                                    },
                                                    on: {
                                                      change: _vm.changeMethod
                                                    },
                                                    model: {
                                                      value: _vm.APISelect,
                                                      callback: function($$v) {
                                                        _vm.APISelect = $$v
                                                      },
                                                      expression: "APISelect"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { md3: "", xs12: "" } },
                                            [
                                              _c(
                                                "v-subheader",
                                                { staticClass: "pl-0" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("AILLMResp")
                                                    ) +
                                                      " " +
                                                      _vm._s(
                                                        _vm.sliderTokenResponse
                                                      )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("v-slider", {
                                                attrs: {
                                                  "thumb-label": "",
                                                  step: "10",
                                                  ticks: "always",
                                                  max: _vm.maxToken,
                                                  min: _vm.minToken
                                                },
                                                model: {
                                                  value:
                                                    _vm.sliderTokenResponse,
                                                  callback: function($$v) {
                                                    _vm.sliderTokenResponse = $$v
                                                  },
                                                  expression:
                                                    "sliderTokenResponse"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("v-flex", { attrs: { md1: "" } }),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            { attrs: { md3: "", xs12: "" } },
                                            [
                                              _c("v-switch", {
                                                attrs: {
                                                  label: this.$t("AILLMStream")
                                                },
                                                model: {
                                                  value: _vm.botStream,
                                                  callback: function($$v) {
                                                    _vm.botStream = $$v
                                                  },
                                                  expression: "botStream"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs12: "" } },
                                            [
                                              _c(
                                                "v-subheader",
                                                { staticClass: "pl-0" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("AILLMTemp")
                                                    ) +
                                                      " " +
                                                      _vm._s(_vm.sliderTemp)
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("v-slider", {
                                                attrs: {
                                                  "thumb-label": "",
                                                  step: "0.01",
                                                  ticks: "always",
                                                  max: _vm.maxTemp,
                                                  min: _vm.minTemp
                                                },
                                                model: {
                                                  value: _vm.sliderTemp,
                                                  callback: function($$v) {
                                                    _vm.sliderTemp = $$v
                                                  },
                                                  expression: "sliderTemp"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-expansion-panel-content",
                    {
                      class: [_vm.getPermissions ? "active" : "hidden"],
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function() {
                            return [
                              _c("div", [
                                _vm._v(_vm._s(_vm.$t("AIResumeTitle")))
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ])
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-layout",
                                {
                                  attrs: {
                                    row: "",
                                    wrap: "",
                                    "justify-space-between": ""
                                  }
                                },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _c("v-textarea", {
                                        attrs: {
                                          label: this.$t("AIResumeContent"),
                                          counter: "",
                                          maxlength: "5000"
                                        },
                                        model: {
                                          value: _vm.promptResume,
                                          callback: function($$v) {
                                            _vm.promptResume = $$v
                                          },
                                          expression: "promptResume"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.products.length
                                    ? _c(
                                        "v-flex",
                                        { attrs: { xs2: "" } },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                color: "primary",
                                                loading:
                                                  _vm.loadingResumePromptAPI,
                                                disabled:
                                                  _vm.loadingResumePromptAPI ||
                                                  !_vm.selectedProduct.length
                                              },
                                              nativeOn: {
                                                click: function($event) {
                                                  return _vm.testPromptResumeAPI.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(_vm.$t("Test")) +
                                                  " api\n                  "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.products.length
                                    ? _c(
                                        "v-flex",
                                        { attrs: { xs8: "" } },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              items: _vm.products,
                                              "item-text": "product",
                                              "item-value": "product",
                                              hint: _vm.selectedProduct.product,
                                              label: this.$t("AIResumeApiID")
                                            },
                                            model: {
                                              value: _vm.selectedProduct,
                                              callback: function($$v) {
                                                _vm.selectedProduct = $$v
                                              },
                                              expression: "selectedProduct"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.products.length
                                    ? _c("v-flex", { attrs: { xs2: "" } })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.urls.length
                                    ? _c(
                                        "v-flex",
                                        { attrs: { xs2: "" } },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                color: "primary",
                                                loading:
                                                  _vm.loadingResumePrompt,
                                                disabled:
                                                  _vm.loadingResumePrompt ||
                                                  !_vm.selectedUrl.length
                                              },
                                              nativeOn: {
                                                click: function($event) {
                                                  return _vm.testPromptResume.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(_vm.$t("Test")) +
                                                  " url\n                  "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.urls.length
                                    ? _c(
                                        "v-flex",
                                        { attrs: { xs8: "" } },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              items: _vm.urls,
                                              "item-text": "url",
                                              "item-value": "url",
                                              hint: _vm.selectedUrl.url,
                                              label: this.$t("AIResumeURL")
                                            },
                                            model: {
                                              value: _vm.selectedUrl,
                                              callback: function($$v) {
                                                _vm.selectedUrl = $$v
                                              },
                                              expression: "selectedUrl"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("br"),
                                          _vm._v(" "),
                                          _vm.loadingResumePrompt ||
                                          _vm.loadingResumePromptAPI
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "text-xs-center tf_loadingResume"
                                                },
                                                [
                                                  _c("v-progress-circular", {
                                                    staticClass:
                                                      "primary--text",
                                                    attrs: {
                                                      indeterminate: "",
                                                      size: 100,
                                                      width: 1
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            : _c(
                                                "div",
                                                [
                                                  _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("AIResume")
                                                      ) + " "
                                                    ),
                                                    _c("br"),
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.contentResume
                                                        )
                                                      )
                                                    ])
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("v-textarea", {
                                                    attrs: {
                                                      name: "contentResumeKeys",
                                                      label: this.$t(
                                                        "AIResumCritere"
                                                      ),
                                                      "auto-grow": "",
                                                      value:
                                                        _vm.contentResumeKeys,
                                                      readonly: ""
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("v-flex", { attrs: { xs2: "" } })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-expansion-panel-content",
                    {
                      class: [_vm.getPermissionsAdmin ? "active" : "hidden"],
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function() {
                            return [
                              _c("div", [
                                _vm._v(
                                  _vm._s(_vm.$t("AIProdTitle")) +
                                    " (" +
                                    _vm._s(_vm.totalProduct) +
                                    ")"
                                )
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ])
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-layout",
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      staticStyle: { width: "80px" },
                                      attrs: { shrink: "" }
                                    },
                                    [
                                      _c("v-text-field", {
                                        staticClass: "mt-0",
                                        attrs: {
                                          "hide-details": "",
                                          "single-line": "",
                                          type: "number"
                                        },
                                        model: {
                                          value: _vm.rangeSliderProduct[0],
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.rangeSliderProduct,
                                              0,
                                              $$v
                                            )
                                          },
                                          expression: "rangeSliderProduct[0]"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { staticClass: "px-3" },
                                    [
                                      _c("v-range-slider", {
                                        attrs: {
                                          max: _vm.totalProduct,
                                          min: _vm.minSliderProduct
                                        },
                                        model: {
                                          value: _vm.rangeSliderProduct,
                                          callback: function($$v) {
                                            _vm.rangeSliderProduct = $$v
                                          },
                                          expression: "rangeSliderProduct"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticStyle: { width: "80px" },
                                      attrs: { shrink: "" }
                                    },
                                    [
                                      _c("v-text-field", {
                                        staticClass: "mt-0",
                                        attrs: {
                                          "hide-details": "",
                                          "single-line": "",
                                          type: "number"
                                        },
                                        model: {
                                          value: _vm.rangeSliderProduct[1],
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.rangeSliderProduct,
                                              1,
                                              $$v
                                            )
                                          },
                                          expression: "rangeSliderProduct[1]"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { x12: "", sm2: "" } },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "text-xs-right" },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                color: "primary",
                                                loading: _vm.loadingData
                                              },
                                              nativeOn: {
                                                click: function($event) {
                                                  return _vm.loadProductsClient.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.$t("AIBtnReload")
                                                  ) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-layout",
                                {
                                  attrs: {
                                    row: "",
                                    wrap: "",
                                    "justify-space-between": ""
                                  }
                                },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs10: "", sm3: "" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          items: _vm.computedActionProduct,
                                          "item-text": "text",
                                          "item-value": "id",
                                          disabled: !_vm.selectedProducts
                                            .length,
                                          label: _vm.$t("actions")
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.actionsProduct()
                                          }
                                        },
                                        model: {
                                          value: _vm.selectActionProduct,
                                          callback: function($$v) {
                                            _vm.selectActionProduct = $$v
                                          },
                                          expression: "selectActionProduct"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs1: "" } },
                                    [_c("v-spacer")],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs6: "", sm3: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          "append-icon": "search",
                                          label: _vm.$t("search"),
                                          "single-line": "",
                                          "hide-details": ""
                                        },
                                        model: {
                                          value: _vm.search,
                                          callback: function($$v) {
                                            _vm.search = $$v
                                          },
                                          expression: "search"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs6: "", sm2: "" } },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "text-xs-right" },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                color: "primary",
                                                loading: _vm.loadingCheckSitemap
                                              },
                                              nativeOn: {
                                                click: function($event) {
                                                  return _vm.checkProduct.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(_vm.$t("searchUrl")) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs6: "", sm2: "" } },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "text-xs-right" },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                color: "primary",
                                                loading:
                                                  _vm.loadingStartEmbedding,
                                                disabled: !_vm.modifKeywordsProduct
                                              },
                                              nativeOn: {
                                                click: function($event) {
                                                  return _vm.startEmbeddingAPI.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.$t("startEmbedding")
                                                  ) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _c("v-data-table", {
                                        staticClass: "elevation-1",
                                        attrs: {
                                          headers: _vm.headersProduct,
                                          items: _vm.products,
                                          search: _vm.search,
                                          "item-key": "product",
                                          "select-all": "",
                                          loading: _vm.loadingData,
                                          "rows-per-page-items": [
                                            10,
                                            25,
                                            50,
                                            100,
                                            200,
                                            500,
                                            1000
                                          ]
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "progress",
                                            fn: function() {
                                              return [
                                                _c("v-progress-linear", {
                                                  attrs: {
                                                    color: "blue",
                                                    indeterminate: ""
                                                  }
                                                })
                                              ]
                                            },
                                            proxy: true
                                          },
                                          {
                                            key: "items",
                                            fn: function(props) {
                                              return [
                                                _c(
                                                  "td",
                                                  [
                                                    _c("v-checkbox", {
                                                      attrs: {
                                                        primary: "",
                                                        "hide-details": ""
                                                      },
                                                      model: {
                                                        value: props.selected,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            props,
                                                            "selected",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "props.selected"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                props.item && props.item.new
                                                  ? _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            props.item.product
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  : _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.openDialogUpdateKeywordProduct(
                                                              props.item
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            props.item.product
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                _vm._v(" "),
                                                props.item &&
                                                props.item.timestamp
                                                  ? _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            props.item.timestamp
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  : _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [_vm._v(" -- ")]
                                                    ),
                                                _vm._v(" "),
                                                props.item && props.item.error
                                                  ? _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _c(
                                                          "v-tooltip",
                                                          {
                                                            attrs: { left: "" }
                                                          },
                                                          [
                                                            _c(
                                                              "template",
                                                              {
                                                                slot:
                                                                  "activator"
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "infos",
                                                                    attrs: {
                                                                      color:
                                                                        "red darken-2",
                                                                      dark: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "error"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "AIErrorSave"
                                                                  )
                                                                )
                                                              )
                                                            ])
                                                          ],
                                                          2
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _c("td", {
                                                      staticClass:
                                                        "text-xs-left"
                                                    }),
                                                _vm._v(" "),
                                                props.item && props.item.new
                                                  ? _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _c(
                                                          "v-tooltip",
                                                          {
                                                            attrs: { left: "" }
                                                          },
                                                          [
                                                            _c(
                                                              "template",
                                                              {
                                                                slot:
                                                                  "activator"
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "infos",
                                                                    attrs: {
                                                                      color:
                                                                        "green darken-2",
                                                                      dark: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "add_circle"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "AINewAddURL"
                                                                  )
                                                                )
                                                              )
                                                            ])
                                                          ],
                                                          2
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _c("td", {
                                                      staticClass:
                                                        "text-xs-left"
                                                    }),
                                                _vm._v(" "),
                                                props.item && props.item.updated
                                                  ? _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _c(
                                                          "v-tooltip",
                                                          {
                                                            attrs: { left: "" }
                                                          },
                                                          [
                                                            _c(
                                                              "template",
                                                              {
                                                                slot:
                                                                  "activator"
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "infos",
                                                                    attrs: {
                                                                      color:
                                                                        "orange darken-2",
                                                                      dark: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "update"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "AIModifKeys"
                                                                  )
                                                                )
                                                              )
                                                            ])
                                                          ],
                                                          2
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _c("td", {
                                                      staticClass:
                                                        "text-xs-left"
                                                    }),
                                                _vm._v(" "),
                                                props.item && props.item.new
                                                  ? _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-center"
                                                      },
                                                      [
                                                        _c(
                                                          "v-tooltip",
                                                          {
                                                            attrs: { left: "" }
                                                          },
                                                          [
                                                            _c(
                                                              "template",
                                                              {
                                                                slot:
                                                                  "activator"
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "infos",
                                                                    attrs: {
                                                                      color:
                                                                        "grey lighten-1",
                                                                      dark: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "info_outline"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "AIKeyNotDispo"
                                                                  )
                                                                )
                                                              )
                                                            ])
                                                          ],
                                                          2
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-center"
                                                      },
                                                      [
                                                        _c(
                                                          "v-tooltip",
                                                          {
                                                            attrs: { left: "" }
                                                          },
                                                          [
                                                            _c(
                                                              "template",
                                                              {
                                                                slot:
                                                                  "activator"
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "infos",
                                                                    attrs: {
                                                                      color:
                                                                        "black lighten-1",
                                                                      dark: ""
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        $event.stopPropagation()
                                                                        return _vm.openDialogUpdateKeywordProduct(
                                                                          props.item
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "info_outline"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "AIKeyEdit"
                                                                  )
                                                                )
                                                              )
                                                            ])
                                                          ],
                                                          2
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "text-xs-center"
                                                  },
                                                  [
                                                    _c(
                                                      "v-tooltip",
                                                      { attrs: { left: "" } },
                                                      [
                                                        _c(
                                                          "template",
                                                          { slot: "activator" },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                attrs: {
                                                                  href:
                                                                    props.item
                                                                      .url,
                                                                  target:
                                                                    "blank"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "infos",
                                                                    attrs: {
                                                                      color:
                                                                        "black lighten-1",
                                                                      dark: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "remove_red_eye"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "AIseePage"
                                                              )
                                                            )
                                                          )
                                                        ])
                                                      ],
                                                      2
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                props.item && props.item.locked
                                                  ? _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-center"
                                                      },
                                                      [
                                                        _c(
                                                          "v-tooltip",
                                                          {
                                                            attrs: { left: "" }
                                                          },
                                                          [
                                                            _c(
                                                              "template",
                                                              {
                                                                slot:
                                                                  "activator"
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "infos",
                                                                    attrs: {
                                                                      small: "",
                                                                      color:
                                                                        "black lighten-1",
                                                                      dark: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "lock"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "AIlockURL"
                                                                  )
                                                                )
                                                              )
                                                            ])
                                                          ],
                                                          2
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ]),
                                        model: {
                                          value: _vm.selectedProducts,
                                          callback: function($$v) {
                                            _vm.selectedProducts = $$v
                                          },
                                          expression: "selectedProducts"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-expansion-panel-content",
                    {
                      class: [_vm.getPermissionsAdmin ? "active" : "hidden"],
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function() {
                            return [
                              _c("div", [
                                _vm._v(
                                  _vm._s(_vm.$t("AIProdURLTitle")) +
                                    " (" +
                                    _vm._s(_vm.totalURLProduct) +
                                    ")"
                                )
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ])
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-layout",
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      staticStyle: { width: "80px" },
                                      attrs: { shrink: "" }
                                    },
                                    [
                                      _c("v-text-field", {
                                        staticClass: "mt-0",
                                        attrs: {
                                          "hide-details": "",
                                          "single-line": "",
                                          type: "number"
                                        },
                                        model: {
                                          value: _vm.rangeSliderURLProduct[0],
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.rangeSliderURLProduct,
                                              0,
                                              $$v
                                            )
                                          },
                                          expression: "rangeSliderURLProduct[0]"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { staticClass: "px-3" },
                                    [
                                      _c("v-range-slider", {
                                        attrs: {
                                          max: _vm.totalURLProduct,
                                          min: _vm.minSliderURLProduct
                                        },
                                        model: {
                                          value: _vm.rangeSliderURLProduct,
                                          callback: function($$v) {
                                            _vm.rangeSliderURLProduct = $$v
                                          },
                                          expression: "rangeSliderURLProduct"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticStyle: { width: "80px" },
                                      attrs: { shrink: "" }
                                    },
                                    [
                                      _c("v-text-field", {
                                        staticClass: "mt-0",
                                        attrs: {
                                          "hide-details": "",
                                          "single-line": "",
                                          type: "number"
                                        },
                                        model: {
                                          value: _vm.rangeSliderURLProduct[1],
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.rangeSliderURLProduct,
                                              1,
                                              $$v
                                            )
                                          },
                                          expression: "rangeSliderURLProduct[1]"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { x12: "", sm2: "" } },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "text-xs-right" },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                color: "primary",
                                                loading: _vm.loadingData
                                              },
                                              nativeOn: {
                                                click: function($event) {
                                                  return _vm.loadURLProductsClient.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.$t("AIBtnReload")
                                                  ) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-layout",
                                {
                                  attrs: {
                                    row: "",
                                    wrap: "",
                                    "justify-space-between": ""
                                  }
                                },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs10: "", sm3: "" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          items: _vm.computedActionUrl,
                                          "item-text": "text",
                                          "item-value": "id",
                                          disabled: !_vm.selectedURLProducts
                                            .length,
                                          label: _vm.$t("actions")
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.actionsURLProduct()
                                          }
                                        },
                                        model: {
                                          value: _vm.selectActionURLProduct,
                                          callback: function($$v) {
                                            _vm.selectActionURLProduct = $$v
                                          },
                                          expression: "selectActionURLProduct"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs1: "" } },
                                    [_c("v-spacer")],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs6: "", sm3: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          "append-icon": "search",
                                          label: _vm.$t("search"),
                                          "single-line": "",
                                          "hide-details": ""
                                        },
                                        model: {
                                          value: _vm.search,
                                          callback: function($$v) {
                                            _vm.search = $$v
                                          },
                                          expression: "search"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs6: "", sm2: "" } },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "text-xs-right" },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                color: "primary",
                                                loading: _vm.loadingCheckSitemap
                                              },
                                              nativeOn: {
                                                click: function($event) {
                                                  return _vm.checkURLProduct.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(_vm.$t("searchUrl")) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs6: "", sm2: "" } },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "text-xs-right" },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                color: "primary",
                                                loading:
                                                  _vm.loadingStartEmbedding,
                                                disabled: !_vm.modifKeywordsURLProduct
                                              },
                                              nativeOn: {
                                                click: function($event) {
                                                  return _vm.startEmbeddingURLProduct.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.$t("startEmbedding")
                                                  ) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _c("v-data-table", {
                                        staticClass: "elevation-1",
                                        attrs: {
                                          headers: _vm.headers,
                                          items: _vm.URLProducts,
                                          search: _vm.search,
                                          "item-key": "url",
                                          "select-all": "",
                                          loading: _vm.loadingData,
                                          "rows-per-page-items": [
                                            10,
                                            25,
                                            50,
                                            100,
                                            200,
                                            500,
                                            1000
                                          ]
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "progress",
                                            fn: function() {
                                              return [
                                                _c("v-progress-linear", {
                                                  attrs: {
                                                    color: "blue",
                                                    indeterminate: ""
                                                  }
                                                })
                                              ]
                                            },
                                            proxy: true
                                          },
                                          {
                                            key: "items",
                                            fn: function(props) {
                                              return [
                                                _c(
                                                  "td",
                                                  [
                                                    _c("v-checkbox", {
                                                      attrs: {
                                                        primary: "",
                                                        "hide-details": ""
                                                      },
                                                      model: {
                                                        value: props.selected,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            props,
                                                            "selected",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "props.selected"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                props.item && props.item.new
                                                  ? _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(props.item.url)
                                                        )
                                                      ]
                                                    )
                                                  : _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.openDialogUpdateKeywordURLProduct(
                                                              props.item
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(props.item.url)
                                                        )
                                                      ]
                                                    ),
                                                _vm._v(" "),
                                                props.item &&
                                                props.item.timestamp
                                                  ? _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            props.item.timestamp
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  : _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [_vm._v(" -- ")]
                                                    ),
                                                _vm._v(" "),
                                                props.item && props.item.error
                                                  ? _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _c(
                                                          "v-tooltip",
                                                          {
                                                            attrs: { left: "" }
                                                          },
                                                          [
                                                            _c(
                                                              "template",
                                                              {
                                                                slot:
                                                                  "activator"
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "infos",
                                                                    attrs: {
                                                                      color:
                                                                        "red darken-2",
                                                                      dark: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "error"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "AIErrorSave"
                                                                  )
                                                                )
                                                              )
                                                            ])
                                                          ],
                                                          2
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _c("td", {
                                                      staticClass:
                                                        "text-xs-left"
                                                    }),
                                                _vm._v(" "),
                                                props.item && props.item.new
                                                  ? _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _c(
                                                          "v-tooltip",
                                                          {
                                                            attrs: { left: "" }
                                                          },
                                                          [
                                                            _c(
                                                              "template",
                                                              {
                                                                slot:
                                                                  "activator"
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "infos",
                                                                    attrs: {
                                                                      color:
                                                                        "green darken-2",
                                                                      dark: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "add_circle"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "AINewAddURL"
                                                                  )
                                                                )
                                                              )
                                                            ])
                                                          ],
                                                          2
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _c("td", {
                                                      staticClass:
                                                        "text-xs-left"
                                                    }),
                                                _vm._v(" "),
                                                props.item && props.item.updated
                                                  ? _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _c(
                                                          "v-tooltip",
                                                          {
                                                            attrs: { left: "" }
                                                          },
                                                          [
                                                            _c(
                                                              "template",
                                                              {
                                                                slot:
                                                                  "activator"
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "infos",
                                                                    attrs: {
                                                                      color:
                                                                        "orange darken-2",
                                                                      dark: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "update"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "AIModifKeys"
                                                                  )
                                                                )
                                                              )
                                                            ])
                                                          ],
                                                          2
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _c("td", {
                                                      staticClass:
                                                        "text-xs-left"
                                                    }),
                                                _vm._v(" "),
                                                props.item && props.item.new
                                                  ? _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-center"
                                                      },
                                                      [
                                                        _c(
                                                          "v-tooltip",
                                                          {
                                                            attrs: { left: "" }
                                                          },
                                                          [
                                                            _c(
                                                              "template",
                                                              {
                                                                slot:
                                                                  "activator"
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "infos",
                                                                    attrs: {
                                                                      color:
                                                                        "grey lighten-1",
                                                                      dark: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "info_outline"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "AIKeyNotDispo"
                                                                  )
                                                                )
                                                              )
                                                            ])
                                                          ],
                                                          2
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-center"
                                                      },
                                                      [
                                                        _c(
                                                          "v-tooltip",
                                                          {
                                                            attrs: { left: "" }
                                                          },
                                                          [
                                                            _c(
                                                              "template",
                                                              {
                                                                slot:
                                                                  "activator"
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "infos",
                                                                    attrs: {
                                                                      color:
                                                                        "black lighten-1",
                                                                      dark: ""
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        $event.stopPropagation()
                                                                        return _vm.openDialogUpdateKeywordURLProduct(
                                                                          props.item
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "info_outline"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "AIKeyEdit"
                                                                  )
                                                                )
                                                              )
                                                            ])
                                                          ],
                                                          2
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "text-xs-center"
                                                  },
                                                  [
                                                    _c(
                                                      "v-tooltip",
                                                      { attrs: { left: "" } },
                                                      [
                                                        _c(
                                                          "template",
                                                          { slot: "activator" },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                attrs: {
                                                                  href:
                                                                    props.item
                                                                      .url,
                                                                  target:
                                                                    "blank"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "infos",
                                                                    attrs: {
                                                                      color:
                                                                        "black lighten-1",
                                                                      dark: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "remove_red_eye"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "AIseePage"
                                                              )
                                                            )
                                                          )
                                                        ])
                                                      ],
                                                      2
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                props.item && props.item.locked
                                                  ? _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-center"
                                                      },
                                                      [
                                                        _c(
                                                          "v-tooltip",
                                                          {
                                                            attrs: { left: "" }
                                                          },
                                                          [
                                                            _c(
                                                              "template",
                                                              {
                                                                slot:
                                                                  "activator"
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "infos",
                                                                    attrs: {
                                                                      small: "",
                                                                      color:
                                                                        "black lighten-1",
                                                                      dark: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "lock"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "AIlockURL"
                                                                  )
                                                                )
                                                              )
                                                            ])
                                                          ],
                                                          2
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ]),
                                        model: {
                                          value: _vm.selectedURLProducts,
                                          callback: function($$v) {
                                            _vm.selectedURLProducts = $$v
                                          },
                                          expression: "selectedURLProducts"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-expansion-panel-content",
                    {
                      class: [_vm.getPermissions ? "active" : "hidden"],
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function() {
                            return [
                              _c("div", [
                                _vm._v(
                                  _vm._s(_vm.$t("AIURLTitle")) +
                                    " (" +
                                    _vm._s(_vm.totalUrl) +
                                    ")"
                                )
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ])
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-layout",
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      staticStyle: { width: "80px" },
                                      attrs: { shrink: "" }
                                    },
                                    [
                                      _c("v-text-field", {
                                        staticClass: "mt-0",
                                        attrs: {
                                          "hide-details": "",
                                          "single-line": "",
                                          type: "number"
                                        },
                                        model: {
                                          value: _vm.rangeSliderUrl[0],
                                          callback: function($$v) {
                                            _vm.$set(_vm.rangeSliderUrl, 0, $$v)
                                          },
                                          expression: "rangeSliderUrl[0]"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { staticClass: "px-3" },
                                    [
                                      _c("v-range-slider", {
                                        attrs: {
                                          max: _vm.totalUrl,
                                          min: _vm.minSliderUrl
                                        },
                                        model: {
                                          value: _vm.rangeSliderUrl,
                                          callback: function($$v) {
                                            _vm.rangeSliderUrl = $$v
                                          },
                                          expression: "rangeSliderUrl"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticStyle: { width: "80px" },
                                      attrs: { shrink: "" }
                                    },
                                    [
                                      _c("v-text-field", {
                                        staticClass: "mt-0",
                                        attrs: {
                                          "hide-details": "",
                                          "single-line": "",
                                          type: "number"
                                        },
                                        model: {
                                          value: _vm.rangeSliderUrl[1],
                                          callback: function($$v) {
                                            _vm.$set(_vm.rangeSliderUrl, 1, $$v)
                                          },
                                          expression: "rangeSliderUrl[1]"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { x12: "", sm2: "" } },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "text-xs-right" },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                color: "primary",
                                                loading: _vm.loadingData
                                              },
                                              nativeOn: {
                                                click: function($event) {
                                                  return _vm.loadUrlsClient(
                                                    "actif"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.$t("AIBtnReload")
                                                  ) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-layout",
                                {
                                  attrs: {
                                    row: "",
                                    wrap: "",
                                    "justify-space-between": ""
                                  }
                                },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs10: "", sm3: "" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          items: _vm.computedActionUrl,
                                          "item-text": "text",
                                          "item-value": "id",
                                          disabled: !_vm.selectedUrls.length,
                                          label: _vm.$t("actions")
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.actionsUrl()
                                          }
                                        },
                                        model: {
                                          value: _vm.selectActionUrl,
                                          callback: function($$v) {
                                            _vm.selectActionUrl = $$v
                                          },
                                          expression: "selectActionUrl"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs1: "" } },
                                    [_c("v-spacer")],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs6: "", sm3: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          "append-icon": "search",
                                          label: _vm.$t("search"),
                                          "single-line": "",
                                          "hide-details": ""
                                        },
                                        model: {
                                          value: _vm.search,
                                          callback: function($$v) {
                                            _vm.search = $$v
                                          },
                                          expression: "search"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs6: "", sm2: "" } },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "text-xs-right" },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                color: "primary",
                                                loading: _vm.loadingCheckSitemap
                                              },
                                              nativeOn: {
                                                click: function($event) {
                                                  return _vm.checkUrls.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(_vm.$t("searchUrl")) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs6: "", sm2: "" } },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "text-xs-right" },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                color: "primary",
                                                loading:
                                                  _vm.loadingStartEmbedding,
                                                disabled: !_vm.modifKeywords
                                              },
                                              nativeOn: {
                                                click: function($event) {
                                                  return _vm.startEmbedding.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.$t("startEmbedding")
                                                  ) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _c("v-data-table", {
                                        staticClass: "elevation-1",
                                        attrs: {
                                          headers: _vm.headers,
                                          items: _vm.urls,
                                          search: _vm.search,
                                          "item-key": "url",
                                          "select-all": "",
                                          loading: _vm.loadingData,
                                          "rows-per-page-items": [
                                            10,
                                            25,
                                            50,
                                            100,
                                            200,
                                            500,
                                            1000
                                          ]
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "progress",
                                            fn: function() {
                                              return [
                                                _c("v-progress-linear", {
                                                  attrs: {
                                                    color: "blue",
                                                    indeterminate: ""
                                                  }
                                                })
                                              ]
                                            },
                                            proxy: true
                                          },
                                          {
                                            key: "items",
                                            fn: function(props) {
                                              return [
                                                _c(
                                                  "td",
                                                  [
                                                    _c("v-checkbox", {
                                                      attrs: {
                                                        primary: "",
                                                        "hide-details": ""
                                                      },
                                                      model: {
                                                        value: props.selected,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            props,
                                                            "selected",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "props.selected"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                props.item && props.item.new
                                                  ? _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(props.item.url)
                                                        )
                                                      ]
                                                    )
                                                  : _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.openDialogUpdateKeyword(
                                                              props.item
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(props.item.url)
                                                        )
                                                      ]
                                                    ),
                                                _vm._v(" "),
                                                props.item &&
                                                props.item.timestamp
                                                  ? _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            props.item.timestamp
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  : _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [_vm._v(" -- ")]
                                                    ),
                                                _vm._v(" "),
                                                props.item && props.item.error
                                                  ? _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _c(
                                                          "v-tooltip",
                                                          {
                                                            attrs: { left: "" }
                                                          },
                                                          [
                                                            _c(
                                                              "template",
                                                              {
                                                                slot:
                                                                  "activator"
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "infos",
                                                                    attrs: {
                                                                      color:
                                                                        "red darken-2",
                                                                      dark: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "error"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "AIErrorSave"
                                                                  )
                                                                )
                                                              )
                                                            ])
                                                          ],
                                                          2
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _c("td", {
                                                      staticClass:
                                                        "text-xs-left"
                                                    }),
                                                _vm._v(" "),
                                                props.item && props.item.new
                                                  ? _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _c(
                                                          "v-tooltip",
                                                          {
                                                            attrs: { left: "" }
                                                          },
                                                          [
                                                            _c(
                                                              "template",
                                                              {
                                                                slot:
                                                                  "activator"
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "infos",
                                                                    attrs: {
                                                                      color:
                                                                        "green darken-2",
                                                                      dark: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "add_circle"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "AINewAddURL"
                                                                  )
                                                                )
                                                              )
                                                            ])
                                                          ],
                                                          2
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _c("td", {
                                                      staticClass:
                                                        "text-xs-left"
                                                    }),
                                                _vm._v(" "),
                                                props.item && props.item.updated
                                                  ? _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left"
                                                      },
                                                      [
                                                        _c(
                                                          "v-tooltip",
                                                          {
                                                            attrs: { left: "" }
                                                          },
                                                          [
                                                            _c(
                                                              "template",
                                                              {
                                                                slot:
                                                                  "activator"
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "infos",
                                                                    attrs: {
                                                                      color:
                                                                        "orange darken-2",
                                                                      dark: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "update"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "AIModifKeys"
                                                                  )
                                                                )
                                                              )
                                                            ])
                                                          ],
                                                          2
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _c("td", {
                                                      staticClass:
                                                        "text-xs-left"
                                                    }),
                                                _vm._v(" "),
                                                props.item && props.item.new
                                                  ? _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-center"
                                                      },
                                                      [
                                                        _c(
                                                          "v-tooltip",
                                                          {
                                                            attrs: { left: "" }
                                                          },
                                                          [
                                                            _c(
                                                              "template",
                                                              {
                                                                slot:
                                                                  "activator"
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "infos",
                                                                    attrs: {
                                                                      color:
                                                                        "grey lighten-1",
                                                                      dark: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "info_outline"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "AIKeyNotDispo"
                                                                  )
                                                                )
                                                              )
                                                            ])
                                                          ],
                                                          2
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-center"
                                                      },
                                                      [
                                                        _c(
                                                          "v-tooltip",
                                                          {
                                                            attrs: { left: "" }
                                                          },
                                                          [
                                                            _c(
                                                              "template",
                                                              {
                                                                slot:
                                                                  "activator"
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "infos",
                                                                    attrs: {
                                                                      color:
                                                                        "black lighten-1",
                                                                      dark: ""
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        $event.stopPropagation()
                                                                        return _vm.openDialogUpdateKeyword(
                                                                          props.item
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "info_outline"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "AIKeyEdit"
                                                                  )
                                                                )
                                                              )
                                                            ])
                                                          ],
                                                          2
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "text-xs-center"
                                                  },
                                                  [
                                                    _c(
                                                      "v-tooltip",
                                                      { attrs: { left: "" } },
                                                      [
                                                        _c(
                                                          "template",
                                                          { slot: "activator" },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                attrs: {
                                                                  href:
                                                                    props.item
                                                                      .url,
                                                                  target:
                                                                    "blank"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "infos",
                                                                    attrs: {
                                                                      color:
                                                                        "black lighten-1",
                                                                      dark: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "remove_red_eye"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "AIseePage"
                                                              )
                                                            )
                                                          )
                                                        ])
                                                      ],
                                                      2
                                                    )
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                props.item && props.item.locked
                                                  ? _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-center"
                                                      },
                                                      [
                                                        _c(
                                                          "v-tooltip",
                                                          {
                                                            attrs: { left: "" }
                                                          },
                                                          [
                                                            _c(
                                                              "template",
                                                              {
                                                                slot:
                                                                  "activator"
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "infos",
                                                                    attrs: {
                                                                      small: "",
                                                                      color:
                                                                        "black lighten-1",
                                                                      dark: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "lock"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "AIlockURL"
                                                                  )
                                                                )
                                                              )
                                                            ])
                                                          ],
                                                          2
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ]),
                                        model: {
                                          value: _vm.selectedUrls,
                                          callback: function($$v) {
                                            _vm.selectedUrls = $$v
                                          },
                                          expression: "selectedUrls"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-expansion-panel-content",
                    {
                      class: [_vm.getPermissions ? "active" : "hidden"],
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function() {
                            return [
                              _c("div", [
                                _vm._v(
                                  _vm._s(_vm.$t("AINoURLTitle")) +
                                    " (" +
                                    _vm._s(_vm.totalUrlInactif) +
                                    ")"
                                )
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ])
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-layout",
                                {
                                  attrs: {
                                    row: "",
                                    wrap: "",
                                    "justify-space-between": ""
                                  }
                                },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs10: "", sm3: "" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          items: _vm.computedActionSuppUrl,
                                          "item-text": "text",
                                          "item-value": "id",
                                          disabled: !_vm.selectedSuppUrls
                                            .length,
                                          label: _vm.$t("actions")
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.actionsSuppUrl()
                                          }
                                        },
                                        model: {
                                          value: _vm.selectActionSuppUrl,
                                          callback: function($$v) {
                                            _vm.selectActionSuppUrl = $$v
                                          },
                                          expression: "selectActionSuppUrl"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs2: "" } },
                                    [_c("v-spacer")],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs6: "", sm4: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          "append-icon": "search",
                                          label: _vm.$t("search"),
                                          "single-line": "",
                                          "hide-details": ""
                                        },
                                        model: {
                                          value: _vm.search,
                                          callback: function($$v) {
                                            _vm.search = $$v
                                          },
                                          expression: "search"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _c("v-data-table", {
                                        staticClass: "elevation-1",
                                        attrs: {
                                          headers: _vm.headersSupp,
                                          items: _vm.listeAllDelUrl,
                                          search: _vm.search,
                                          "item-key": "url",
                                          "select-all": "",
                                          loading: _vm.loadingDataInactif,
                                          "rows-per-page-items": [
                                            10,
                                            25,
                                            50,
                                            100,
                                            200
                                          ]
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "progress",
                                            fn: function() {
                                              return [
                                                _c("v-progress-linear", {
                                                  attrs: {
                                                    color: "blue",
                                                    indeterminate: ""
                                                  }
                                                })
                                              ]
                                            },
                                            proxy: true
                                          },
                                          {
                                            key: "items",
                                            fn: function(props) {
                                              return [
                                                _c(
                                                  "td",
                                                  [
                                                    _c("v-checkbox", {
                                                      attrs: {
                                                        primary: "",
                                                        "hide-details": ""
                                                      },
                                                      model: {
                                                        value: props.selected,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            props,
                                                            "selected",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "props.selected"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "text-xs-left"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(props.item.url)
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "text-xs-center"
                                                  },
                                                  [
                                                    _c(
                                                      "v-tooltip",
                                                      { attrs: { left: "" } },
                                                      [
                                                        _c(
                                                          "template",
                                                          { slot: "activator" },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                attrs: {
                                                                  href:
                                                                    props.item
                                                                      .url,
                                                                  target:
                                                                    "blank"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "infos",
                                                                    attrs: {
                                                                      color:
                                                                        "black lighten-1",
                                                                      dark: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "remove_red_eye"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "AIseePage"
                                                              )
                                                            )
                                                          )
                                                        ])
                                                      ],
                                                      2
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            }
                                          }
                                        ]),
                                        model: {
                                          value: _vm.selectedSuppUrls,
                                          callback: function($$v) {
                                            _vm.selectedSuppUrls = $$v
                                          },
                                          expression: "selectedSuppUrls"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-expansion-panel-content",
                    {
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function() {
                            return [
                              _c("div", [_vm._v(_vm._s(_vm.$t("AIDocTitle")))])
                            ]
                          },
                          proxy: true
                        }
                      ])
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-layout",
                                {
                                  attrs: {
                                    row: "",
                                    wrap: "",
                                    "justify-space-between": ""
                                  }
                                },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs10: "", sm3: "" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          items: _vm.computedActionFile,
                                          "item-text": "text",
                                          "item-value": "id",
                                          disabled: !_vm.selectedFiles.length,
                                          label: _vm.$t("actions")
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.actionsFile()
                                          }
                                        },
                                        model: {
                                          value: _vm.selectActionFile,
                                          callback: function($$v) {
                                            _vm.selectActionFile = $$v
                                          },
                                          expression: "selectActionFile"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs2: "", sm1: "" } },
                                    [_c("v-spacer")],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs6: "", sm5: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          "append-icon": "search",
                                          label: _vm.$t("search"),
                                          "single-line": "",
                                          "hide-details": ""
                                        },
                                        model: {
                                          value: _vm.search,
                                          callback: function($$v) {
                                            _vm.search = $$v
                                          },
                                          expression: "search"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs6: "", sm2: "" } },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "text-xs-right" },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: { color: "primary" },
                                              nativeOn: {
                                                click: function($event) {
                                                  return _vm.importFile.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(_vm.$t("importDoc")) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs1: "", sm1: "" } },
                                    [_c("v-spacer")],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _c("v-data-table", {
                                        staticClass: "elevation-1",
                                        attrs: {
                                          headers: _vm.headersFile,
                                          items: _vm.files,
                                          search: _vm.search,
                                          "item-key": "file",
                                          "select-all": "",
                                          loading: _vm.loadingDataFiles,
                                          "rows-per-page-items": [
                                            10,
                                            25,
                                            50,
                                            100,
                                            200
                                          ]
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "progress",
                                            fn: function() {
                                              return [
                                                _c("v-progress-linear", {
                                                  attrs: {
                                                    height: "2",
                                                    color: "blue",
                                                    indeterminate: ""
                                                  }
                                                })
                                              ]
                                            },
                                            proxy: true
                                          },
                                          {
                                            key: "items",
                                            fn: function(props) {
                                              return [
                                                _c(
                                                  "td",
                                                  [
                                                    _c("v-checkbox", {
                                                      attrs: {
                                                        primary: "",
                                                        "hide-details": ""
                                                      },
                                                      model: {
                                                        value: props.selected,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            props,
                                                            "selected",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "props.selected"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                props.item.numChunk
                                                  ? _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.openDialogChunkFile(
                                                              props.item
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            props.item.file
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  : _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.openDialogFile(
                                                              props.item
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            props.item.file
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                _vm._v(" "),
                                                props.item.numChunk
                                                  ? _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.openDialogChunkFile(
                                                              props.item
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            props.item.numChunk
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  : _c(
                                                      "td",
                                                      {
                                                        staticClass:
                                                          "text-xs-left",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.openDialogFile(
                                                              props.item
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_vm._v("résumé")]
                                                    ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "text-xs-center px-2"
                                                  },
                                                  [
                                                    _c(
                                                      "v-tooltip",
                                                      { attrs: { left: "" } },
                                                      [
                                                        _c(
                                                          "template",
                                                          { slot: "activator" },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                staticClass:
                                                                  "infos",
                                                                attrs: {
                                                                  color:
                                                                    "black lighten-1",
                                                                  dark: ""
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.openDialogChunkFile(
                                                                      props.item
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "info_outline"
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "affSegDoc"
                                                              )
                                                            )
                                                          )
                                                        ])
                                                      ],
                                                      2
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            }
                                          }
                                        ]),
                                        model: {
                                          value: _vm.selectedFiles,
                                          callback: function($$v) {
                                            _vm.selectedFiles = $$v
                                          },
                                          expression: "selectedFiles"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-expansion-panel-content",
                    {
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function() {
                            return [
                              _c("div", [
                                _vm._v("FAQ (" + _vm._s(_vm.faqs.length) + ")")
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ])
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-layout",
                                {
                                  attrs: {
                                    row: "",
                                    wrap: "",
                                    "justify-space-between": ""
                                  }
                                },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs10: "", sm3: "" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          items: _vm.computedActionFAQ,
                                          "item-text": "text",
                                          "item-value": "id",
                                          disabled: !_vm.selectedFaqs.length,
                                          label: _vm.$t("actions")
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.actionsFAQ()
                                          }
                                        },
                                        model: {
                                          value: _vm.selectActionFAQ,
                                          callback: function($$v) {
                                            _vm.selectActionFAQ = $$v
                                          },
                                          expression: "selectActionFAQ"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs1: "", sm1: "" } },
                                    [_c("v-spacer")],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs6: "", sm5: "" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          "append-icon": "search",
                                          label: _vm.$t("search"),
                                          "single-line": "",
                                          "hide-details": ""
                                        },
                                        model: {
                                          value: _vm.search,
                                          callback: function($$v) {
                                            _vm.search = $$v
                                          },
                                          expression: "search"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs6: "", sm2: "" } },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "text-xs-right" },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: { color: "primary" },
                                              nativeOn: {
                                                click: function($event) {
                                                  return _vm.newFAQ.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(_vm.$t("addFaq")) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs1: "", sm1: "" } },
                                    [_c("v-spacer")],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _c("v-data-table", {
                                        staticClass: "elevation-1",
                                        attrs: {
                                          headers: _vm.headersFAQ,
                                          items: _vm.faqs,
                                          search: _vm.search,
                                          "item-key": "index",
                                          "select-all": "",
                                          loading: _vm.loadingData,
                                          "rows-per-page-items": [
                                            10,
                                            25,
                                            50,
                                            100,
                                            200
                                          ]
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "progress",
                                            fn: function() {
                                              return [
                                                _c("v-progress-linear", {
                                                  attrs: {
                                                    color: "blue",
                                                    indeterminate: ""
                                                  }
                                                })
                                              ]
                                            },
                                            proxy: true
                                          },
                                          {
                                            key: "items",
                                            fn: function(props) {
                                              return [
                                                _c("tr", [
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-xs-center"
                                                    },
                                                    [
                                                      _c("v-checkbox", {
                                                        attrs: {
                                                          primary: "",
                                                          "hide-details": ""
                                                        },
                                                        model: {
                                                          value: props.selected,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              props,
                                                              "selected",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "props.selected"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-xs-right",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.openDialogUpdateFAQ(
                                                            props.item
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(props.item.index)
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-xs-left",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.openDialogUpdateFAQ(
                                                            props.item
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          props.item.question
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-xs-left",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.openDialogUpdateFAQ(
                                                            props.item
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          props.item.reponse
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    {
                                                      staticClass:
                                                        "text-xs-right"
                                                    },
                                                    [
                                                      _c(
                                                        "v-tooltip",
                                                        { attrs: { left: "" } },
                                                        [
                                                          _c(
                                                            "template",
                                                            {
                                                              slot: "activator"
                                                            },
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  staticClass:
                                                                    "infos",
                                                                  attrs: {
                                                                    color:
                                                                      "black lighten-1",
                                                                    dark: ""
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                      return _vm.openDialogUpdateFAQ(
                                                                        props.item
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [_vm._v("edit")]
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "editFAQ"
                                                                )
                                                              )
                                                            )
                                                          ])
                                                        ],
                                                        2
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ])
                                              ]
                                            }
                                          }
                                        ]),
                                        model: {
                                          value: _vm.selectedFaqs,
                                          callback: function($$v) {
                                            _vm.selectedFaqs = $$v
                                          },
                                          expression: "selectedFaqs"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-expansion-panel-content",
                    {
                      class: [_vm.getPermissionsAdmin ? "active" : "hidden"],
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function() {
                            return [
                              _c("div", [
                                _vm._v(_vm._s(_vm.$t("AIAnalysTitle")))
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ])
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-card-title",
                            { attrs: { "primary-title": "" } },
                            [
                              _c("div", [
                                _c("div", {
                                  staticClass: "body-2 pl-3",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      this.$t("AIAnalysExemple")
                                    )
                                  }
                                })
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-layout",
                                {
                                  attrs: {
                                    row: "",
                                    wrap: "",
                                    "justify-space-between": ""
                                  }
                                },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs10: "", sm3: "" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          items: _vm.computedActionAnalyseChat,
                                          "item-text": "text",
                                          "item-value": "id",
                                          disabled: !_vm.selectedAnalyseChat
                                            .length,
                                          label: _vm.$t("actions")
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.actionsAnalyseChat()
                                          }
                                        },
                                        model: {
                                          value: _vm.selectActionAnalyseChat,
                                          callback: function($$v) {
                                            _vm.selectActionAnalyseChat = $$v
                                          },
                                          expression: "selectActionAnalyseChat"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs2: "" } },
                                    [_c("v-spacer")],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-flex", { attrs: { xs6: "", sm3: "" } }),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs6: "", sm2: "" } },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            outline: "",
                                            color: "primary"
                                          },
                                          nativeOn: {
                                            click: function($event) {
                                              return _vm.addAnalyseChat.apply(
                                                null,
                                                arguments
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(_vm.$t("AIAnalysAdd")) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _c("v-data-table", {
                                        staticClass: "elevation-1",
                                        attrs: {
                                          headers: _vm.headersAnalyseChat,
                                          items: _vm.analyseChat,
                                          "item-key": "q",
                                          "select-all": ""
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "progress",
                                            fn: function() {
                                              return [
                                                _c("v-progress-linear", {
                                                  attrs: {
                                                    height: "2",
                                                    color: "blue",
                                                    indeterminate: ""
                                                  }
                                                })
                                              ]
                                            },
                                            proxy: true
                                          },
                                          {
                                            key: "items",
                                            fn: function(props) {
                                              return [
                                                _c(
                                                  "td",
                                                  [
                                                    _c("v-checkbox", {
                                                      attrs: {
                                                        primary: "",
                                                        "hide-details": ""
                                                      },
                                                      model: {
                                                        value: props.selected,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            props,
                                                            "selected",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "props.selected"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "text-xs-left",
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return _vm.openDialogModifAnalyseChat(
                                                          props.item
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v(_vm._s(props.item.q))]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass: "text-xs-left",
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return _vm.openDialogModifAnalyseChat(
                                                          props.item
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v(_vm._s(props.item.a))]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "td",
                                                  {
                                                    staticClass:
                                                      "text-xs-center px-2"
                                                  },
                                                  [
                                                    _c(
                                                      "v-tooltip",
                                                      { attrs: { left: "" } },
                                                      [
                                                        _c(
                                                          "template",
                                                          { slot: "activator" },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                staticClass:
                                                                  "infos",
                                                                attrs: {
                                                                  color:
                                                                    "black lighten-1",
                                                                  dark: ""
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.openDialogModifAnalyseChat(
                                                                      props.item
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "info_outline"
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "affSegDoc"
                                                              )
                                                            )
                                                          )
                                                        ])
                                                      ],
                                                      2
                                                    )
                                                  ],
                                                  1
                                                )
                                              ]
                                            }
                                          }
                                        ]),
                                        model: {
                                          value: _vm.selectedAnalyseChat,
                                          callback: function($$v) {
                                            _vm.selectedAnalyseChat = $$v
                                          },
                                          expression: "selectedAnalyseChat"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-expansion-panel-content",
                    {
                      class: [_vm.getPermissionsAdmin ? "active" : "hidden"],
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function() {
                            return [
                              _c("div", [_vm._v(_vm._s(_vm.$t("AIStatTitle")))])
                            ]
                          },
                          proxy: true
                        }
                      ])
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-card-title",
                            { attrs: { "primary-title": "" } },
                            [
                              _c("div", [
                                _c("div", { staticClass: "body-2 pl-3" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.$t("AIStatContent")) +
                                      "\n                "
                                  )
                                ])
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-card-text",
                            [
                              _c(
                                "v-layout",
                                {
                                  attrs: {
                                    row: "",
                                    wrap: "",
                                    "justify-space-between": ""
                                  }
                                },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs12: "", md4: "" } },
                                            [
                                              _c("v-select", {
                                                attrs: {
                                                  dense: "",
                                                  items: _vm.periods,
                                                  label: _vm._f("cap")(
                                                    _vm.$t("period")
                                                  ),
                                                  "prepend-icon": "date_range"
                                                },
                                                model: {
                                                  value: _vm.period,
                                                  callback: function($$v) {
                                                    _vm.period = $$v
                                                  },
                                                  expression: "period"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("v-flex", { attrs: { md2: "" } }),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            { attrs: { xs12: "", md3: "" } },
                                            [
                                              _c(
                                                "v-dialog",
                                                {
                                                  attrs: {
                                                    lazy: "",
                                                    "full-width": "",
                                                    width: "290px",
                                                    disabled: _vm.period != 0
                                                  },
                                                  model: {
                                                    value: _vm.modalStart,
                                                    callback: function($$v) {
                                                      _vm.modalStart = $$v
                                                    },
                                                    expression: "modalStart"
                                                  }
                                                },
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      slot: "activator",
                                                      label: _vm._f("cap")(
                                                        _vm.$t("startDate")
                                                      ),
                                                      "prepend-icon": "event",
                                                      readonly: "",
                                                      disabled: _vm.period != 0
                                                    },
                                                    on: {
                                                      blur: function($event) {
                                                        _vm.dateStartPicker = _vm.parseDate(
                                                          _vm.dateStartDisplayed
                                                        )
                                                      }
                                                    },
                                                    slot: "activator",
                                                    model: {
                                                      value:
                                                        _vm.dateStartDisplayed,
                                                      callback: function($$v) {
                                                        _vm.dateStartDisplayed = $$v
                                                      },
                                                      expression:
                                                        "dateStartDisplayed"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("v-date-picker", {
                                                    attrs: {
                                                      "first-day-of-week": 1,
                                                      min:
                                                        _vm.allowedDatesStart
                                                          .min,
                                                      max:
                                                        _vm.allowedDatesStart
                                                          .max,
                                                      locale: _vm.$i18n.locale,
                                                      scrollable: "",
                                                      color: "primary"
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        _vm.dateStartDisplayed = _vm.formatDate(
                                                          $event
                                                        )
                                                        _vm.modalStart = false
                                                      }
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.dateStartPicker,
                                                      callback: function($$v) {
                                                        _vm.dateStartPicker = $$v
                                                      },
                                                      expression:
                                                        "dateStartPicker"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            { attrs: { xs12: "", md3: "" } },
                                            [
                                              _c(
                                                "v-dialog",
                                                {
                                                  attrs: {
                                                    lazy: "",
                                                    "full-width": "",
                                                    width: "290px",
                                                    disabled: _vm.period != 0
                                                  },
                                                  model: {
                                                    value: _vm.modalEnd,
                                                    callback: function($$v) {
                                                      _vm.modalEnd = $$v
                                                    },
                                                    expression: "modalEnd"
                                                  }
                                                },
                                                [
                                                  _c("v-text-field", {
                                                    attrs: {
                                                      slot: "activator",
                                                      label: _vm._f("cap")(
                                                        _vm.$t("endDate")
                                                      ),
                                                      "prepend-icon": "event",
                                                      readonly: "",
                                                      disabled: _vm.period != 0
                                                    },
                                                    on: {
                                                      blur: function($event) {
                                                        _vm.dateEndPicker = _vm.parseDate(
                                                          _vm.dateEndDisplayed
                                                        )
                                                      }
                                                    },
                                                    slot: "activator",
                                                    model: {
                                                      value:
                                                        _vm.dateEndDisplayed,
                                                      callback: function($$v) {
                                                        _vm.dateEndDisplayed = $$v
                                                      },
                                                      expression:
                                                        "dateEndDisplayed"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("v-date-picker", {
                                                    attrs: {
                                                      "first-day-of-week": 1,
                                                      min:
                                                        _vm.allowedDatesEnd.min,
                                                      max:
                                                        _vm.allowedDatesEnd.max,
                                                      locale: _vm.$i18n.locale,
                                                      scrollable: "",
                                                      color: "primary"
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        _vm.dateEndDisplayed = _vm.formatDate(
                                                          $event
                                                        )
                                                        _vm.modalEnd = false
                                                      }
                                                    },
                                                    model: {
                                                      value: _vm.dateEndPicker,
                                                      callback: function($$v) {
                                                        _vm.dateEndPicker = $$v
                                                      },
                                                      expression:
                                                        "dateEndPicker"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs6: "", sm3: "", md2: "" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "grey--text text--darken-2"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("cap")(_vm.$t("AIStatsTP"))
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "headline teal--text" },
                                        [_vm._v(_vm._s(_vm.nbPrompt))]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs6: "", sm3: "", md2: "" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "grey--text text--darken-2"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("cap")(_vm.$t("AIStatTC"))
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "headline blue--text" },
                                        [_vm._v(_vm._s(_vm.nbCompletion))]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs6: "", sm3: "", md2: "" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "grey--text text--darken-2"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("cap")(_vm.$t("AIStatTT"))
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "headline pink--text" },
                                        [_vm._v(_vm._s(_vm.nbTotal))]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs6: "", sm6: "", md2: "" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label: _vm._f("cap")(
                                            _vm.$t("dataInterval")
                                          ),
                                          items: _vm.intervals,
                                          "return-object": ""
                                        },
                                        model: {
                                          value: _vm.interval,
                                          callback: function($$v) {
                                            _vm.interval = $$v
                                          },
                                          expression: "interval"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs6: "", sm6: "", md2: "" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label: _vm._f("cap")(
                                            _vm.$t("AIStatT")
                                          ),
                                          items: _vm.utilisations,
                                          "return-object": ""
                                        },
                                        model: {
                                          value: _vm.utilisation,
                                          callback: function($$v) {
                                            _vm.utilisation = $$v
                                          },
                                          expression: "utilisation"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("highcharts", {
                                attrs: { options: _vm.options }
                              }),
                              _vm._v(" "),
                              _c(
                                "v-expansion-panel",
                                [
                                  _c(
                                    "v-expansion-panel-content",
                                    {
                                      scopedSlots: _vm._u([
                                        {
                                          key: "header",
                                          fn: function() {
                                            return [
                                              _c(
                                                "div",
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("info")
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t("AIStatDetail")
                                                      )
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          },
                                          proxy: true
                                        }
                                      ])
                                    },
                                    [
                                      _vm._v(" "),
                                      _c(
                                        "v-card",
                                        [
                                          _c("v-card-title"),
                                          _vm._v(" "),
                                          _c(
                                            "v-card-text",
                                            [
                                              _c(
                                                "v-layout",
                                                {
                                                  attrs: { row: "", wrap: "" }
                                                },
                                                [
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      attrs: {
                                                        xs6: "",
                                                        sm3: ""
                                                      }
                                                    },
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          "append-icon":
                                                            "search",
                                                          label: this.$t(
                                                            "search"
                                                          ),
                                                          "single-line": "",
                                                          "hide-details": ""
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.searchTokens,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.searchTokens = $$v
                                                          },
                                                          expression:
                                                            "searchTokens"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-flex",
                                                    { attrs: { xs12: "" } },
                                                    [
                                                      _c("v-data-table", {
                                                        staticClass:
                                                          "elevation-1",
                                                        attrs: {
                                                          headers:
                                                            _vm.headersTokens,
                                                          items: _vm.tokens,
                                                          search:
                                                            _vm.searchTokens,
                                                          "item-key":
                                                            "timestamp",
                                                          loading:
                                                            _vm.loadingStatsToken,
                                                          "rows-per-page-items": [
                                                            10,
                                                            25,
                                                            50,
                                                            100,
                                                            200
                                                          ]
                                                        },
                                                        scopedSlots: _vm._u([
                                                          {
                                                            key: "progress",
                                                            fn: function() {
                                                              return [
                                                                _c(
                                                                  "v-progress-linear",
                                                                  {
                                                                    attrs: {
                                                                      color:
                                                                        "blue",
                                                                      indeterminate:
                                                                        ""
                                                                    }
                                                                  }
                                                                )
                                                              ]
                                                            },
                                                            proxy: true
                                                          },
                                                          {
                                                            key: "items",
                                                            fn: function(
                                                              props
                                                            ) {
                                                              return [
                                                                _c(
                                                                  "td",
                                                                  {
                                                                    staticClass:
                                                                      "text-xs-left"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.afficheDate(
                                                                          props
                                                                            .item
                                                                            .timestamp
                                                                        )
                                                                      )
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "td",
                                                                  {
                                                                    staticClass:
                                                                      "text-xs-left"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        props
                                                                          .item
                                                                          .session_chat
                                                                      )
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "td",
                                                                  {
                                                                    staticClass:
                                                                      "text-xs-left"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        props
                                                                          .item
                                                                          .description
                                                                      )
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "td",
                                                                  {
                                                                    staticClass:
                                                                      "text-xs-left"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        props
                                                                          .item
                                                                          .model
                                                                      )
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "td",
                                                                  {
                                                                    staticClass:
                                                                      "text-xs-left"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        props
                                                                          .item
                                                                          .tokens_prompt
                                                                      )
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "td",
                                                                  {
                                                                    staticClass:
                                                                      "text-xs-left"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        props
                                                                          .item
                                                                          .tokens_completion
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ])
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-expansion-panel-content",
                    {
                      class: [_vm.getPermissionsAdmin ? "active" : "hidden"],
                      scopedSlots: _vm._u([
                        {
                          key: "header",
                          fn: function() {
                            return [
                              _c("div", [
                                _vm._v(_vm._s(_vm.$t("AIDataAutoTitle")))
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ])
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "v-card",
                        [
                          _vm.loadingPrompt
                            ? _c(
                                "div",
                                { staticClass: "text-xs-center tf_loading" },
                                [
                                  _c("v-progress-circular", {
                                    staticClass: "primary--text",
                                    attrs: {
                                      indeterminate: "",
                                      size: 100,
                                      width: 1
                                    }
                                  })
                                ],
                                1
                              )
                            : _c(
                                "v-card-text",
                                [
                                  _c(
                                    "v-container",
                                    [
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs12: "" } },
                                            [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("AIDataSitemap")
                                                  )
                                                )
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            { attrs: { xs12: "", lg6: "" } },
                                            [
                                              _c(
                                                "v-layout",
                                                {
                                                  attrs: { row: "", wrap: "" }
                                                },
                                                [
                                                  _c(
                                                    "v-flex",
                                                    { attrs: { xs12: "" } },
                                                    [
                                                      _c("div", {
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            this.$t(
                                                              "AIDataExempl"
                                                            )
                                                          )
                                                        }
                                                      })
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-flex",
                                                    { attrs: { xs12: "" } },
                                                    [
                                                      _c("v-text-field", {
                                                        attrs: {
                                                          label: this.$t(
                                                            "AIDataScann"
                                                          )
                                                        },
                                                        model: {
                                                          value: _vm.pageScanne,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.pageScanne = $$v
                                                          },
                                                          expression:
                                                            "pageScanne"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-flex",
                                                    { attrs: { xs12: "" } },
                                                    [
                                                      _c(
                                                        "v-flex",
                                                        { attrs: { xs12: "" } },
                                                        [
                                                          _vm._v(
                                                            "\n                          " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "AIDataPeriod"
                                                                )
                                                              ) +
                                                              "\n                        "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("v-slider", {
                                                        attrs: {
                                                          "tick-labels":
                                                            _vm.timeLabels,
                                                          max: 3,
                                                          step: "1",
                                                          ticks: "always",
                                                          "tick-size": "2"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.timeSelected,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.timeSelected = $$v
                                                          },
                                                          expression:
                                                            "timeSelected"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      attrs: {
                                                        xs12: "",
                                                        md6: ""
                                                      }
                                                    },
                                                    [
                                                      _c("v-switch", {
                                                        attrs: {
                                                          label: this.$t(
                                                            "AIDataMAJ"
                                                          )
                                                        },
                                                        model: {
                                                          value: _vm.majCronTab,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.majCronTab = $$v
                                                          },
                                                          expression:
                                                            "majCronTab"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-flex",
                                                    {
                                                      attrs: {
                                                        xs12: "",
                                                        md6: ""
                                                      }
                                                    },
                                                    [
                                                      _c("v-switch", {
                                                        attrs: {
                                                          disabled: !_vm.majCronTab,
                                                          label: this.$t(
                                                            "AIDataSave"
                                                          )
                                                        },
                                                        model: {
                                                          value: _vm.majUrlAuto,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.majUrlAuto = $$v
                                                          },
                                                          expression:
                                                            "majUrlAuto"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.afficheStatusCron
                                                    ? _c(
                                                        "v-flex",
                                                        { attrs: { xs8: "" } },
                                                        [
                                                          _vm.statusSaveCron
                                                            ? _c(
                                                                "v-alert",
                                                                {
                                                                  attrs: {
                                                                    value: true,
                                                                    color:
                                                                      "success",
                                                                    icon:
                                                                      "check_circle",
                                                                    outline: ""
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        _vm.infoCron
                                                                      ) +
                                                                      "\n                        "
                                                                  )
                                                                ]
                                                              )
                                                            : _c(
                                                                "v-alert",
                                                                {
                                                                  attrs: {
                                                                    value: true,
                                                                    color:
                                                                      "error",
                                                                    icon:
                                                                      "warning",
                                                                    outline: ""
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        _vm.infoCron
                                                                      ) +
                                                                      "\n                        "
                                                                  )
                                                                ]
                                                              )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-xs-right" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        loading: _vm.loadingSavePrompt,
                        disabled: _vm.loadingSavePrompt || !_vm.modifPrompt
                      },
                      nativeOn: {
                        click: function($event) {
                          return _vm.savePrompt.apply(null, arguments)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(_vm.$t("save")) + "\n        "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", scrollable: "", "max-width": "490" },
          model: {
            value: _vm.showDialogDeleteParsing,
            callback: function($$v) {
              _vm.showDialogDeleteParsing = $$v
            },
            expression: "showDialogDeleteParsing"
          }
        },
        [
          _c("wz-dialog-confirm", {
            attrs: {
              titleDialogConfirm: _vm.$t("suppPars"),
              contentDialogConfirm: _vm.SelectedParsingSupp.name,
              showDialogConfirmation: false
            },
            on: {
              closeDialogConfirm: _vm.justCloseDialogConfirmParsing,
              justCloseDialogConfirm: _vm.justCloseDialogConfirmParsing,
              submitDialogConfirm: _vm.submitDeleteParsing
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", scrollable: "", "max-width": "490" },
          model: {
            value: _vm.showDialogDeleteAnalyseChat,
            callback: function($$v) {
              _vm.showDialogDeleteAnalyseChat = $$v
            },
            expression: "showDialogDeleteAnalyseChat"
          }
        },
        [
          _c("wz-dialog-confirm", {
            attrs: {
              titleDialogConfirm:
                _vm.selectedAnalyseChat.length > 1
                  ? _vm.$t("suppAnalysChat-s")
                  : _vm.$t("suppAnalysChat"),
              contentDialogConfirm: _vm.listeSelectedAnalyseChat,
              showDialogConfirmation: false,
              loadingModifDialog: _vm.loadingModifAnalyseChat
            },
            on: {
              closeDialogConfirm: _vm.justCloseDialogConfirmAnalyseChat,
              justCloseDialogConfirm: _vm.justCloseDialogConfirmAnalyseChat,
              submitDialogConfirm: _vm.submitDeleteAnalyseChatConfirm
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", scrollable: "", "max-width": "490" },
          model: {
            value: _vm.showDialogDeleteFile,
            callback: function($$v) {
              _vm.showDialogDeleteFile = $$v
            },
            expression: "showDialogDeleteFile"
          }
        },
        [
          _c("wz-dialog-confirm", {
            attrs: {
              titleDialogConfirm:
                _vm.selectedFiles.length > 1
                  ? _vm.$t("suppFile-s")
                  : _vm.$t("suppFile"),
              contentDialogConfirm: _vm.listeSelectedFile,
              showDialogConfirmation: false,
              loadingModifDialog: _vm.loadingModifFile
            },
            on: {
              closeDialogConfirm: _vm.justCloseDialogConfirmFile,
              justCloseDialogConfirm: _vm.justCloseDialogConfirmFile,
              submitDialogConfirm: _vm.submitDeleteFileConfirm
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", scrollable: "", "max-width": "490" },
          model: {
            value: _vm.showDialogLock,
            callback: function($$v) {
              _vm.showDialogLock = $$v
            },
            expression: "showDialogLock"
          }
        },
        [
          _c("wz-dialog-confirm", {
            attrs: {
              titleDialogConfirm:
                _vm.selectedUrls.length > 1
                  ? _vm.$t("lockURL-s")
                  : _vm.$t("lockURL"),
              contentDialogConfirm: _vm.listeSelectedUrl,
              contentDialogRes: _vm.messageResDialog,
              showDialogConfirmation: false,
              loadingModifDialog: _vm.loadingModifUrl,
              loadingRes: _vm.loadingRes,
              startLoading: _vm.startLoading,
              endLoading: _vm.endLoading,
              closeDialogUniquement: _vm.closeDialogUniquement
            },
            on: {
              closeDialogConfirm: _vm.justCloseDialogLock,
              justCloseDialogConfirm: _vm.justCloseDialogLock,
              submitDialogConfirm: _vm.submitLockConfirm
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", scrollable: "", "max-width": "490" },
          model: {
            value: _vm.showDialogLockURLProduct,
            callback: function($$v) {
              _vm.showDialogLockURLProduct = $$v
            },
            expression: "showDialogLockURLProduct"
          }
        },
        [
          _c("wz-dialog-confirm", {
            attrs: {
              titleDialogConfirm:
                _vm.selectedURLProducts.length > 1
                  ? _vm.$t("lockURL-s")
                  : _vm.$t("lockURL"),
              contentDialogConfirm: _vm.listeSelectedURLProduct,
              contentDialogRes: _vm.messageResDialog,
              showDialogConfirmation: false,
              loadingModifDialog: _vm.loadingModifUrl,
              loadingRes: _vm.loadingRes,
              startLoading: _vm.startLoading,
              endLoading: _vm.endLoading,
              closeDialogUniquement: _vm.closeDialogUniquement
            },
            on: {
              closeDialogConfirm: _vm.justCloseDialogLock,
              justCloseDialogConfirm: _vm.justCloseDialogLock,
              submitDialogConfirm: _vm.submitLockConfirmURLProduct
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", scrollable: "", "max-width": "490" },
          model: {
            value: _vm.showDialogLockProduct,
            callback: function($$v) {
              _vm.showDialogLockProduct = $$v
            },
            expression: "showDialogLockProduct"
          }
        },
        [
          _c("wz-dialog-confirm", {
            attrs: {
              titleDialogConfirm:
                _vm.selectedProducts.length > 1
                  ? _vm.$t("lockProd-s")
                  : _vm.$t("lockProd"),
              contentDialogConfirm: _vm.listeSelectedProduct,
              contentDialogRes: _vm.messageResDialog,
              showDialogConfirmation: false,
              loadingModifDialog: _vm.loadingModifUrl,
              loadingRes: _vm.loadingRes,
              startLoading: _vm.startLoading,
              endLoading: _vm.endLoading,
              closeDialogUniquement: _vm.closeDialogUniquement
            },
            on: {
              closeDialogConfirm: _vm.justCloseDialogLock,
              justCloseDialogConfirm: _vm.justCloseDialogLock,
              submitDialogConfirm: _vm.submitLockConfirmProduct
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", scrollable: "", "max-width": "490" },
          model: {
            value: _vm.showDialogDeletesFAQ,
            callback: function($$v) {
              _vm.showDialogDeletesFAQ = $$v
            },
            expression: "showDialogDeletesFAQ"
          }
        },
        [
          _c("wz-dialog-confirm", {
            attrs: {
              titleDialogConfirm:
                _vm.selectedFaqs.length > 1
                  ? _vm.$t("suppFAQ-s")
                  : _vm.$t("suppFAQ"),
              contentDialogConfirm: _vm.listeSelectedFAQ,
              contentDialogRes: _vm.messageResDialog,
              showDialogConfirmation: false,
              loadingModifDialog: _vm.loadingModifUrl,
              closeDialogUniquement: _vm.closeDialogUniquement
            },
            on: {
              closeDialogConfirm: _vm.justCloseDialogConfirmFAQ,
              justCloseDialogConfirm: _vm.justCloseDialogConfirmFAQ,
              submitDialogConfirm: _vm.submitDeleteConfirmFAQ
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", scrollable: "", "max-width": "490" },
          model: {
            value: _vm.showDialogDelete,
            callback: function($$v) {
              _vm.showDialogDelete = $$v
            },
            expression: "showDialogDelete"
          }
        },
        [
          _c("wz-dialog-confirm", {
            attrs: {
              titleDialogConfirm:
                _vm.selectedUrls.length > 1
                  ? _vm.$t("suppURL-s")
                  : _vm.$t("suppURL"),
              contentDialogConfirm: _vm.listeSelectedUrl,
              contentDialogRes: _vm.messageResDialog,
              showDialogConfirmation: false,
              loadingModifDialog: _vm.loadingModifUrl,
              closeDialogUniquement: _vm.closeDialogUniquement
            },
            on: {
              closeDialogConfirm: _vm.justCloseDialogConfirm,
              justCloseDialogConfirm: _vm.justCloseDialogConfirm,
              submitDialogConfirm: _vm.submitDeleteConfirm
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", scrollable: "", "max-width": "490" },
          model: {
            value: _vm.showDialogDeleteProduct,
            callback: function($$v) {
              _vm.showDialogDeleteProduct = $$v
            },
            expression: "showDialogDeleteProduct"
          }
        },
        [
          _c("wz-dialog-confirm", {
            attrs: {
              titleDialogConfirm:
                _vm.selectedProducts.length > 1
                  ? _vm.$t("suppProd-s")
                  : _vm.$t("suppProd"),
              contentDialogConfirm: _vm.listeSelectedProduct,
              contentDialogRes: _vm.messageResDialog,
              showDialogConfirmation: false,
              loadingModifDialog: _vm.loadingModifUrl,
              closeDialogUniquement: _vm.closeDialogUniquement
            },
            on: {
              closeDialogConfirm: _vm.justCloseDialogConfirm,
              justCloseDialogConfirm: _vm.justCloseDialogConfirm,
              submitDialogConfirm: _vm.submitDeleteConfirmProduct
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", scrollable: "", "max-width": "490" },
          model: {
            value: _vm.showDialogDeleteURLProduct,
            callback: function($$v) {
              _vm.showDialogDeleteURLProduct = $$v
            },
            expression: "showDialogDeleteURLProduct"
          }
        },
        [
          _c("wz-dialog-confirm", {
            attrs: {
              titleDialogConfirm:
                _vm.selectedURLProducts.length > 1
                  ? _vm.$t("suppProd-s")
                  : _vm.$t("suppProd"),
              contentDialogConfirm: _vm.listeSelectedURLProduct,
              contentDialogRes: _vm.messageResDialog,
              showDialogConfirmation: false,
              loadingModifDialog: _vm.loadingModifUrl,
              closeDialogUniquement: _vm.closeDialogUniquement
            },
            on: {
              closeDialogConfirm: _vm.justCloseDialogConfirm,
              justCloseDialogConfirm: _vm.justCloseDialogConfirm,
              submitDialogConfirm: _vm.submitDeleteConfirmURLProduct
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", scrollable: "", "max-width": "490" },
          model: {
            value: _vm.showDialogDeleteSupp,
            callback: function($$v) {
              _vm.showDialogDeleteSupp = $$v
            },
            expression: "showDialogDeleteSupp"
          }
        },
        [
          _c("wz-dialog-confirm", {
            attrs: {
              titleDialogConfirm:
                _vm.selectedSuppUrls.length > 1
                  ? _vm.$t("suppURL-s")
                  : _vm.$t("suppURL"),
              contentDialogConfirm: _vm.listeSelectedSuppUrl,
              contentDialogRes: _vm.messageResDialog,
              showDialogConfirmation: false,
              loadingModifDialog: _vm.loadingModifUrl,
              closeDialogUniquement: _vm.closeDialogUniquement
            },
            on: {
              closeDialogConfirm: _vm.justCloseDialogConfirmSupp,
              justCloseDialogConfirm: _vm.justCloseDialogConfirmSupp,
              submitDialogConfirm: _vm.submitDeleteConfirmSupp
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", scrollable: "", "max-width": "490" },
          model: {
            value: _vm.showDialogEmbedding,
            callback: function($$v) {
              _vm.showDialogEmbedding = $$v
            },
            expression: "showDialogEmbedding"
          }
        },
        [
          _c("wz-dialog-confirm", {
            attrs: {
              titleDialogConfirm: _vm.$t("startEmbedding"),
              contentDialogConfirm:
                _vm.$t("startEmbeddingText") +
                "<strong>" +
                _vm.siteSelected.LIC_KEY +
                "</strong>",
              showDialogConfirmation: false,
              contentDialogRes: _vm.messageResDialog,
              startLoading: _vm.startLoading,
              endLoading: _vm.endLoading,
              loadingModifDialog: _vm.loadingEmbeddingUrl,
              loadingRes: _vm.loadingRes,
              closeDialogUniquement: _vm.closeDialogUniquement
            },
            on: {
              closeDialogConfirm: _vm.justCloseDialogEmdedding,
              justCloseDialogConfirm: _vm.justCloseDialogEmdedding,
              submitDialogConfirm: _vm.submitEmbeddingConfirm
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", scrollable: "", "max-width": "490" },
          model: {
            value: _vm.showDialogEmbeddingURLProduct,
            callback: function($$v) {
              _vm.showDialogEmbeddingURLProduct = $$v
            },
            expression: "showDialogEmbeddingURLProduct"
          }
        },
        [
          _c("wz-dialog-confirm", {
            attrs: {
              titleDialogConfirm: _vm.$t("startEmbedding"),
              contentDialogConfirm:
                _vm.$t("startEmbeddingText") +
                "<strong>" +
                _vm.siteSelected.LIC_KEY +
                "</strong>",
              showDialogConfirmation: false,
              contentDialogRes: _vm.messageResDialog,
              startLoading: _vm.startLoading,
              endLoading: _vm.endLoading,
              loadingModifDialog: _vm.loadingEmbeddingUrl,
              loadingRes: _vm.loadingRes,
              closeDialogUniquement: _vm.closeDialogUniquement
            },
            on: {
              closeDialogConfirm: _vm.justCloseDialogEmdeddingURLProduct,
              justCloseDialogConfirm: _vm.justCloseDialogEmdeddingURLProduct,
              submitDialogConfirm: _vm.submitEmbeddingURLProductConfirm
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", scrollable: "", "max-width": "490" },
          model: {
            value: _vm.showDialogEmbeddingAPI,
            callback: function($$v) {
              _vm.showDialogEmbeddingAPI = $$v
            },
            expression: "showDialogEmbeddingAPI"
          }
        },
        [
          _c("wz-dialog-confirm", {
            attrs: {
              titleDialogConfirm: _vm.$t("startEmbeddingAPI"),
              contentDialogConfirm:
                _vm.$t("startEmbeddingAPIText") +
                "<strong>" +
                _vm.siteSelected.LIC_KEY +
                "</strong>",
              showDialogConfirmation: false,
              contentDialogRes: _vm.messageResDialog,
              startLoading: _vm.startLoading,
              endLoading: _vm.endLoading,
              loadingModifDialog: _vm.loadingEmbeddingUrl,
              loadingRes: _vm.loadingRes,
              closeDialogUniquement: _vm.closeDialogUniquement
            },
            on: {
              closeDialogConfirm: _vm.justCloseDialogEmdeddingAPI,
              justCloseDialogConfirm: _vm.justCloseDialogEmdeddingAPI,
              submitDialogConfirm: _vm.submitEmbeddingAPIConfirm
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", scrollable: "", "max-width": "490" },
          model: {
            value: _vm.showDialogModifKeyword,
            callback: function($$v) {
              _vm.showDialogModifKeyword = $$v
            },
            expression: "showDialogModifKeyword"
          }
        },
        [
          _c("wz-dialog-openai-keyword", {
            attrs: {
              type: "url",
              titleDialog: _vm.$t("modifKeywords"),
              afficheDialog: _vm.showDialogModifKeyword,
              dataDialog: _vm.keywordUrl
            },
            on: {
              closeDialog: _vm.justCloseDialogKeyword,
              justCloseDialog: _vm.justCloseDialogKeyword,
              majData: _vm.majData
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", scrollable: "", "max-width": "490" },
          model: {
            value: _vm.showDialogModifKeywordURLProduct,
            callback: function($$v) {
              _vm.showDialogModifKeywordURLProduct = $$v
            },
            expression: "showDialogModifKeywordURLProduct"
          }
        },
        [
          _c("wz-dialog-openai-keyword", {
            attrs: {
              type: "urlProduct",
              titleDialog: _vm.$t("modifKeywords"),
              afficheDialog: _vm.showDialogModifKeywordURLProduct,
              dataDialog: _vm.keywordUrl
            },
            on: {
              closeDialog: _vm.justCloseDialogKeywordURLProduct,
              justCloseDialog: _vm.justCloseDialogKeywordURLProduct,
              majData: _vm.majDataURLProduct
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", scrollable: "", "max-width": "490" },
          model: {
            value: _vm.showDialogModifKeywordProduct,
            callback: function($$v) {
              _vm.showDialogModifKeywordProduct = $$v
            },
            expression: "showDialogModifKeywordProduct"
          }
        },
        [
          _c("wz-dialog-openai-keyword-product", {
            attrs: {
              titleDialog: _vm.$t("modifKeywords"),
              afficheDialog: _vm.showDialogModifKeywordProduct,
              dataDialog: _vm.keywordProduct
            },
            on: {
              closeDialog: _vm.justCloseDialogKeywordProduct,
              justCloseDialog: _vm.justCloseDialogKeywordProduct,
              majData: _vm.majDataProduct
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", scrollable: "", "max-width": "490" },
          model: {
            value: _vm.showDialogModifFAQ,
            callback: function($$v) {
              _vm.showDialogModifFAQ = $$v
            },
            expression: "showDialogModifFAQ"
          }
        },
        [
          _c("wz-dialog-openai-faq", {
            attrs: {
              titleDialog: _vm.addFAQ
                ? _vm.$t("addNewFAQ")
                : _vm.$t("modifFAQ"),
              afficheDialog: _vm.showDialogModifFAQ,
              dataDialog: _vm.addFAQ ? {} : _vm.questAnsw,
              numFAQ: this.numFAQ,
              addFAQ: this.addFAQ
            },
            on: {
              closeDialog: _vm.justCloseDialogFAQ,
              justCloseDialog: _vm.justCloseDialogFAQ,
              majFAQ: _vm.majFAQ
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", scrollable: "", "max-width": "490" },
          model: {
            value: _vm.showDialogAddKeyword,
            callback: function($$v) {
              _vm.showDialogAddKeyword = $$v
            },
            expression: "showDialogAddKeyword"
          }
        },
        [
          _c("wz-dialog-confirm", {
            attrs: {
              titleDialogConfirm:
                _vm.selectedUrls.length > 1
                  ? _vm.$t("addKnow-s")
                  : _vm.$t("addKnow"),
              contentDialogConfirm: _vm.messageKeywords,
              showDialogConfirmation: false,
              contentDialogRes: _vm.messageResDialog,
              startLoading: _vm.startLoading,
              endLoading: _vm.endLoading,
              loadingModifDialog: _vm.loadingModifUrl,
              loadingRes: _vm.loadingRes,
              closeDialogUniquement: _vm.closeDialogUniquement
            },
            on: {
              closeDialogConfirm: _vm.justCloseDialogConfirm,
              justCloseDialogConfirm: _vm.justCloseDialogConfirm,
              submitDialogConfirm: _vm.submitAddKeywords
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", scrollable: "", "max-width": "490" },
          model: {
            value: _vm.showDialogAddKeywordProduct,
            callback: function($$v) {
              _vm.showDialogAddKeywordProduct = $$v
            },
            expression: "showDialogAddKeywordProduct"
          }
        },
        [
          _c("wz-dialog-confirm", {
            attrs: {
              titleDialogConfirm:
                _vm.selectedProducts.length > 1
                  ? _vm.$t("addKnow-s")
                  : _vm.$t("addKnow"),
              contentDialogConfirm: _vm.messageKeywords,
              showDialogConfirmation: false,
              contentDialogRes: _vm.messageResDialog,
              startLoading: _vm.startLoading,
              endLoading: _vm.endLoading,
              loadingModifDialog: _vm.loadingModifUrl,
              loadingRes: _vm.loadingRes,
              closeDialogUniquement: _vm.closeDialogUniquement
            },
            on: {
              closeDialogConfirm: _vm.justCloseDialogConfirm,
              justCloseDialogConfirm: _vm.justCloseDialogConfirm,
              submitDialogConfirm: _vm.submitAddKeywordsProducts
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", scrollable: "", "max-width": "490" },
          model: {
            value: _vm.showDialogAddKeywordURLProduct,
            callback: function($$v) {
              _vm.showDialogAddKeywordURLProduct = $$v
            },
            expression: "showDialogAddKeywordURLProduct"
          }
        },
        [
          _c("wz-dialog-confirm", {
            attrs: {
              titleDialogConfirm:
                _vm.selectedURLProducts.length > 1
                  ? _vm.$t("addKnow-s")
                  : _vm.$t("addKnow"),
              contentDialogConfirm: _vm.messageKeywords,
              showDialogConfirmation: false,
              contentDialogRes: _vm.messageResDialog,
              startLoading: _vm.startLoading,
              endLoading: _vm.endLoading,
              loadingModifDialog: _vm.loadingModifUrl,
              loadingRes: _vm.loadingRes,
              closeDialogUniquement: _vm.closeDialogUniquement
            },
            on: {
              closeDialogConfirm: _vm.justCloseDialogConfirm,
              justCloseDialogConfirm: _vm.justCloseDialogConfirm,
              submitDialogConfirm: _vm.submitAddKeywordsURLProducts
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", scrollable: "", "max-width": "490" },
          model: {
            value: _vm.showDialogImportPDF,
            callback: function($$v) {
              _vm.showDialogImportPDF = $$v
            },
            expression: "showDialogImportPDF"
          }
        },
        [
          _c("wz-dialog-import-pdf", {
            attrs: {
              titleDialog: _vm.$t("importDoc"),
              afficheDialog: _vm.showDialogImportPDF
            },
            on: {
              addFile: _vm.addFile,
              justCloseDialog: _vm.justCloseDialogImportPDF
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { scrollable: "", "max-width": "80%" },
          model: {
            value: _vm.showDialogChunkPDF,
            callback: function($$v) {
              _vm.showDialogChunkPDF = $$v
            },
            expression: "showDialogChunkPDF"
          }
        },
        [
          _c("wz-dialog-file-chunk", {
            attrs: {
              titleDialog: _vm.$t("segPDF"),
              afficheDialog: _vm.showDialogChunkPDF,
              licKey: this.siteSelected.LIC_KEY,
              dataDialog: _vm.selectedFileChunk
            },
            on: { justCloseDialog: _vm.justCloseDialogChunkPDF }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { scrollable: "", "max-width": "80%" },
          model: {
            value: _vm.showDialogResume,
            callback: function($$v) {
              _vm.showDialogResume = $$v
            },
            expression: "showDialogResume"
          }
        },
        [
          _c("wz-dialog-file-resume", {
            attrs: {
              titleDialog: _vm.$t("résumé"),
              afficheDialog: _vm.showDialogResume,
              licKey: this.siteSelected.LIC_KEY,
              dataDialog: _vm.selectedFileChunk
            },
            on: { justCloseDialog: _vm.justCloseDialogResume }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", scrollable: "", "max-width": "490" },
          model: {
            value: _vm.showDialogAddAnalyseChat,
            callback: function($$v) {
              _vm.showDialogAddAnalyseChat = $$v
            },
            expression: "showDialogAddAnalyseChat"
          }
        },
        [
          _c("wz-dialog-analyse-chat", {
            attrs: {
              titleDialog: _vm.titleAnalyseChat,
              modifDialog: _vm.modifDialog,
              afficheDialog: _vm.showDialogAddAnalyseChat,
              dataDialog: _vm.selectedModifAnalyseChat
            },
            on: {
              addAnalyse: _vm.saveAnalyseChat,
              modifAnalyse: _vm.modifAnalyseChat,
              justCloseDialog: _vm.justCloseDialogAnalyseChat
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", scrollable: "", "max-width": "490" },
          model: {
            value: _vm.showDialogAddUrls,
            callback: function($$v) {
              _vm.showDialogAddUrls = $$v
            },
            expression: "showDialogAddUrls"
          }
        },
        [
          _c("wz-dialog-add-urls", {
            attrs: {
              titleDialogConfirm: _vm.$t("searchUrl"),
              contentDialogConfirm:
                _vm.$t("searchUrlTxt") +
                "<br>" +
                this.$t("AIMLicence") +
                " <strong>" +
                _vm.siteSelected.LIC_KEY +
                "</strong>",
              showDialogConfirmation: false,
              contentDialogRes: _vm.messageResDialog,
              startLoading: _vm.startLoading,
              endLoading: _vm.endLoading,
              loadingModifDialog: _vm.loadingSearchUrl,
              loadingRes: _vm.loadingRes,
              closeDialogUniquement: _vm.closeDialogUniquement
            },
            on: {
              closeDialogConfirm: _vm.justCloseDialogAddUrls,
              justCloseDialogConfirm: _vm.justCloseDialogAddUrls,
              submitDialogConfirm: _vm.submitCheckUrls
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { scrollable: "", "max-width": "80%" },
          model: {
            value: _vm.showDialogEnhancePrompt,
            callback: function($$v) {
              _vm.showDialogEnhancePrompt = $$v
            },
            expression: "showDialogEnhancePrompt"
          }
        },
        [
          _c("wz-dialog-enhance-prompt", {
            attrs: {
              titleDialogConfirm: "Améliorer le prompt avec lI.A.",
              contentDialogConfirm:
                "Utiliser l'I.A. pour améliorer (ou créer) cette partie de prompt",
              showDialogConfirmation: false,
              contentDialogRes: _vm.messageResDialog,
              currentPromptData: {
                preview: _vm.prompt,
                personality: _vm.prompt_personality,
                environment: _vm.prompt_environment,
                objectif: _vm.prompt_objectif,
                communication: _vm.prompt_communication,
                questions: _vm.prompt_questions,
                rules: _vm.prompt_rules,
                tools: _vm.prompt_tools,
                custom: _vm.prompt_custom
              },
              startLoading: _vm.startLoading,
              endLoading: _vm.endLoading,
              loadingRes: _vm.loadingRes,
              closeDialogUniquement: _vm.closeDialogUniquement
            },
            on: {
              applyEnhancedPromptSection: _vm.applyEnhancedPromptSection,
              closeDialogConfirm: _vm.justCloseDialogEnhancePrompt,
              justCloseDialogConfirm: _vm.justCloseDialogEnhancePrompt,
              submitDialogConfirm: _vm.submitEnhancePrompt
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "80%" },
          model: {
            value: _vm.showDialogVersionPrompt,
            callback: function($$v) {
              _vm.showDialogVersionPrompt = $$v
            },
            expression: "showDialogVersionPrompt"
          }
        },
        [
          _c("wz-dialog-version-prompt", {
            attrs: {
              titleDialogConfirm: "Restaurer une version antérieure",
              contentDialogConfirm:
                "Choisissez une ancienne version du prompt et restaurer cette version",
              showDialogConfirmation: false,
              contentDialogRes: _vm.messageResDialog,
              startLoading: _vm.startLoading,
              endLoading: _vm.endLoading,
              loadingRes: _vm.loadingRes,
              closeDialogUniquement: _vm.closeDialogUniquement,
              currentPromptData: {
                preview: _vm.prompt,
                personality: _vm.prompt_personality,
                environment: _vm.prompt_environment,
                objectif: _vm.prompt_objectif,
                communication: _vm.prompt_communication,
                questions: _vm.prompt_questions,
                rules: _vm.prompt_rules,
                tools: _vm.prompt_tools,
                custom: _vm.prompt_custom
              }
            },
            on: {
              restorePromptSection: _vm.restorePromptSectionFromHistory,
              closeDialogConfirm: _vm.justCloseDialogVersionPrompt,
              justCloseDialogConfirm: _vm.justCloseDialogVersionPrompt,
              submitDialogConfirm: _vm.submitVersionPrompt
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-71445aaf", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71445aaf","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/botbuilder/openAIConfig.vue
// module id = null
// module chunks = 